<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <a-select 
                v-if="userInfo.tenant_id == 1"
                class="query_field"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')"
                :options="tenantOptions"
                @change="handleSelectChange('tenant')"
            ></a-select>
            <a-select
                class="query_field"
                v-model:value="searchForm.frame_number" 
                allowClear
                showSearch
                :placeholder="t('cycling.frameNumber')" 
                :options="frameNumberOptions"
                @change="handleSelectChange('frame_number')"
                @search="(val)=>getFrameAndMotor(val,'frame_number')"
            >
                <template v-if="fetching" #notFoundContent>
                    <a-spin size="small" />
                </template>
            </a-select>
            <!-- <a-select
                class="query_field" 
                v-model:value="searchForm.assembly_code" 
                allowClear
                showSearch
                :placeholder="t('cycling.assemblyCode')" 
                :options="motorCodeOptions" 
                @change="handleSelectChange('assembly_code')"
                @search="(val)=>getFrameAndMotor(val,'assembly_code')"
            >
                <template v-if="fetching" #notFoundContent>
                    <a-spin size="small" />
                </template>
            </a-select> -->
            <a-input
                v-model:value="searchForm.assembly_code"
                :placeholder="t('cycling.assemblyCode2')"
                style="width: 200px; margin-right:10px"
                @change="handleInputChange('assembly_code')"
                @search="(val)=>getFrameAndMotor(val,'assembly_code')"
            />
            <a-input
                class="query_field"
                v-model:value="searchForm.email"
                :placeholder="t('access.userEmail')"
                allowClear
                @change="handleInputChangeEmail()"
            />
            <a-button type="primary" size="small" style="margin-right:10px" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.search') }}
            </a-button>
        </div>

        <div>
            <Table
                ref="tableRef"
                class="table"
                :table="table"
                @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'bikeList')"
                @expandRow="expandRow"
            >
                <template v-slot:customCol="{props}">
                    <template v-if="props.column.key === 'email'">
                        {{ props.record.email }}
                        <EyeInvisibleOutlined v-if="props.record.show_sensitive_email && props.record.email !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveData', props.record, 'email')"/>
                        <EyeOutlined v-if="!props.record.show_sensitive_email && props.record.email !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveData', props.record, 'email')"/>
                    </template>
                    <template v-if="props.column.key === 'phone_key'">
                        {{ props.record.phone_key }}
                        <EyeInvisibleOutlined v-if="props.record.show_sensitive_phone_key && props.record.phone_key !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveData', props.record, 'phone_key')"/>
                        <EyeOutlined v-if="!props.record.show_sensitive_phone_key && props.record.phone_key !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveData', props.record, 'phone_key')"/>
                    </template>
                    <template v-if="props.column.key === 'motor_key'">
                        {{ props.record.motor_key }}
                        <EyeInvisibleOutlined v-if="props.record.show_sensitive_motor_key && props.record.motor_key !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveData', props.record, 'motor_key')"/>
                        <EyeOutlined v-if="!props.record.show_sensitive_motor_key && props.record.motor_key !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveData', props.record, 'motor_key')"/>
                    </template>
                    <template v-if="props.column.key === 'wheel_circumference'">
                       <div v-if="props.record.wheel_circumference !== '-'">{{ props.record.wheel_circumference }} mm</div>
                       <div v-else>-</div>
                    </template>
                    <template v-if="props.column.key === 'max_speed'">
                       <div v-if="props.record.max_speed !== '-'">{{ props.record.max_speed }} km/h</div>
                       <div v-else>-</div>
                    </template>
                    <template v-if="props.column.key === 'upgrade_torque_status'">
                        <a-select
                            ref="select"
                            v-model:value="props.record.upgrade_torque_status"
                            size="small"
                            style="width: 90px"
                            :disabled="props.record.upgrade_torque_status === '' || !props.record.hasTorqueUpgradeAuth"
                            @select="handle('cancelTorque', props.record)"
                        >
                            <a-select-option
                                v-for="(item,index) in upgradeTorqueStatusOptions"
                                :key="index"
                                :value="item.value"
                            >{{item.label}}</a-select-option>
                        </a-select>
                    </template>
                    <template v-if="props.column.key === 'motor_change_status'">
                        <a-select
                            ref="select"
                            v-model:value="props.record.motor_change_status"
                            size="small"
                            style="width: 130px"
                            :disabled="props.record.change_motor == undefined || props.record.change_motor == 2 || !props.record.hasMotorReplaceAuth "
                            @select="(val)=>handle('cancleMotorReplace', props.record)"
                        >
                            <a-select-option
                                v-for="(item,index) in motorChangeStatusOptions"
                                :key="index"
                                :value="item.value"
                            >{{item.label}}</a-select-option>
                        </a-select>
                    </template>
                </template>

                <!-- 父表格操作按钮 -->
                <template v-slot:tableAction="{props}">
                    <template v-if="props.column.key === 'action'">
                        <a-dropdown>
                            <template #overlay>
                                <a-menu>
                                    <a-menu-item
                                        v-for="(item, index) in dropdownMenu"
                                        :key="index"
                                        :disabled="getFunDisabled(props.record, item.key)"
                                        @click="handle(item.key, props.record)"
                                    >
                                        {{ item.name }}
                                    </a-menu-item>
                                </a-menu>
                            </template>
                            <a-button size="small">
                                {{ $t('access.editAuth') }} <DownOutlined />
                            </a-button>
                        </a-dropdown>
                        <a-divider type="vertical" v-if="userInfo.tenant_id == 0 || userInfo.tenant_id == 1" />
                        <a-button v-if="userInfo.tenant_id == 0 || userInfo.tenant_id == 1"  size="small" @click="handle('log', props.record)">
                            {{ $t('access.log') }}
                        </a-button>
                        <a-divider type="vertical" />
                        <a-dropdown>
                            <template #overlay>
                                <a-menu>
                                    <a-menu-item @click="handle('appBind', props.record)">
                                        {{ $t('access.appBind') }}
                                    </a-menu-item>
                                    <a-menu-item @click="handle('torqueUpgradeRecord', props.record)">
                                        {{ $t('access.torqueUpgrade') }}
                                    </a-menu-item>
                                    <a-menu-item @click="handle('motorReplacement', props.record)">
                                        {{ $t('access.motorReplacement') }}
                                    </a-menu-item>
                                    <a-menu-item @click="handle('currentSetting', props.record)">
                                        {{ $t('access.currentSetting') }}
                                    </a-menu-item>
                                    <a-menu-item @click="handle('poweronSession', props.record)">
                                        {{ $t('access.poweronSession') }}
                                    </a-menu-item>
                                    <a-divider style="margin:5px" v-if="userInfo.tenant_id == 1 && userInfo.id != 13250"/>
                                    <a-menu-item v-if="userInfo.tenant_id == 1 && userInfo.id != 13250" @click="handle('ebikeSetting', props.record)">
                                        {{ $t('access.ebikeSetting') }}
                                    </a-menu-item>
                                    <a-menu-item v-if="userInfo.tenant_id == 1 && userInfo.id != 13250" @click="handle('ebikeRepair', props.record)">
                                        {{ $t('access.ebikeRepair') }}
                                    </a-menu-item>
                                    <a-menu-item v-if="userInfo.tenant_id == 1 && userInfo.id != 13250" @click="handle('ebikeAuth', props.record)">
                                        {{ $t('access.ebikeAuth') }}
                                    </a-menu-item>
                                </a-menu>
                            </template>
                            <a-button size="small">
                                {{ $t('access.changeRecord') }} <DownOutlined />
                            </a-button>
                        </a-dropdown>
                        <a-divider type="vertical" v-if="userInfo.tenant_id == 1 && userInfo.id != 13250" />
                        <a-dropdown >
                            <template #overlay>
                                <a-menu>
                                    <a-menu-item v-if="userInfo.tenant_id == 1" @click="handle('poweronPosition', props.record)">
                                        {{ $t('access.poweronPosition') }}
                                    </a-menu-item>
                                    <a-menu-item v-if="userInfo.tenant_id == 1" @click="handle('summary', props.record)">
                                        {{ $t('access.summary') }}
                                    </a-menu-item>
                                    <a-menu-item v-if="userInfo.tenant_id == 1" @click="handle('ebikeBarcode', props.record)">
                                        {{ $t('access.ebikeBarcode') }}
                                    </a-menu-item>
                                    <a-menu-item v-if="userInfo.tenant_id == 1" @click="handle('motorQRCode', props.record)">
                                        {{ $t('access.motorQRCode') }}
                                    </a-menu-item>
                                    <a-menu-item v-if="userInfo.tenant_id == 1" @click="handle('exportRawData', props.record)">
                                        {{ $t('access.exportRawData') }}
                                    </a-menu-item>
                                </a-menu>
                            </template>
                            <a-button size="small" v-if="userInfo.tenant_id == 1 && userInfo.id != 13250">
                                {{ $t('access.more') }} <DownOutlined />
                            </a-button>
                        </a-dropdown>
                    </template>
                </template>

                <!-- 子表格操作按钮 -->
                <template v-slot:childTableAction="{props}">
                    <template v-if="props.column.key === 'action'">
                        <div v-if="props.record.part_no != '00ef' && props.record.part_no != '00f0' && props.record.part_no != '00f1'">
                            <a-button v-if="showDeletePartBtn" type="primary" ghost size="small" :disabled="props.record.disabled" @click="handle('deletePart',props.record)">{{$t('access.deletePart')}}</a-button>
                            <a-button v-else type="primary" ghost size="small" :disabled="props.record.disabled" @click="handle('deletePart',props.record)">{{$t('access.deletePart')}}</a-button>
                        </div>
                        <div v-else>-</div>
                    </template>
                </template>
            </Table>
        </div>

        <!-- 扭矩升级 -->
        <a-modal 
            v-model:open="torqueUpdateVisible"
            :closable="false"
            :width="450"
            centered
            :cancelText="t('base.cancel')"
            :okText="t('base.confirm')"
            @ok="torqueUpgrade"
        >
            <div class="queryUserTitle">{{ $t('access.editTorque') }}</div>
            <a-select
                ref="select"
                v-model:value="torque"
                style="width: 100%"
                :options="rowData.torqueOptions"
            >
            </a-select>
        </a-modal>

        <!-- 轮径、最大速度 -->
        <a-modal 
            v-model:open="editModalVisible"
            :title="editModalTitle"
            centered
            :force-render="true" 
            width="650px"
            @ok="saveWheelCircumferenceAndMaxSpeed"
            @cancel="cancelEditModal"
        >
            <div v-if="editModalType === 'wheelCircumference'">
                <div class="wheelCircumferenceInfo color_4b2cc3 font12">
                    <div class="marginBottom5">
                        <ExclamationCircleOutlined />
                        {{ $t('access.valueRange') }}
                    </div>
                    <div >
                        <ExclamationCircleOutlined />
                        {{ $t('access.referenceValue') }}: {{ rowData.wheel_circumference_min }}mm ~ {{ rowData.wheel_circumference_max }}mm 
                    </div>
                </div>
                
                <a-input-number 
                    v-model:value="rowData.wheel_circumference" 
                    :min="rowData.wheel_circumference_min" 
                    :max="rowData.wheel_circumference_max" 
                    :precision="0"
                    style="width: 100%" 
                    addon-after="mm"
                    @change="changeWheelCircumference"
                />
                
            </div>

            <div v-if="editModalType === 'maxSpeed'">
                <div class="wheelCircumferenceInfo color_4b2cc3 font12">
                    <div >
                        <ExclamationCircleOutlined />
                        {{ $t('access.referenceValue') }}: 20km/h~25km/h
                    </div>
                </div>
                <a-input-number 
                    v-model:value="rowData.max_speed" 
                    :min="20" 
                    :max="25" 
                    :precision="0"
                    style="width: 100%" 
                    addon-after="km/h"
                />
            </div>
        </a-modal>

        <!-- 邦车条码 -->
        <a-modal
            v-model:open="barcodeVisible"
            :title="t('access.ebikeBarcode')"
            centered
            :footer="null"
            style="text-align:center"
        >
            <div style="margin-top: 16px;">
                <QRCodeVue :value="barcodeUrl" :size="150"></QRCodeVue>
            </div>
        </a-modal>

        <!-- 电机二维码 -->
        <a-modal
            v-model:open="qrcodeVisible"
            :title="t('access.motorQRCode')"
            centered
            :footer="null"
            style="text-align:center"
        >
            <div style="margin-top: 16px;">
                <QRCodeVue :value="qrcodeUrl" :size="150"></QRCodeVue>
            </div>
        </a-modal>

        <!-- 导出原始数据弹窗 -->
        <a-modal 
            v-model:open="rawDataVisible"
            :title="t('access.exportRawData')"
            centered
            width="600px"
            :footer="null"
            :bodyStyle="{ minHeight: '200px', overflowY: 'auto' }"
            style="text-align:center"
        >
            <div class="exportFormContainer">
                <div class="exportFormItem">
                    <span class="exportLabel">{{ $t('access.frameNumber') }} :</span>
                    <span class="required">*</span>
                    <a-input v-model:value="exportForm.frame_number" disabled :placeholder="t('access.frameNumber')" style="width:291px" />
                </div>
                <div class="exportFormItem">
                    <span class="exportLabel">{{ $t('access.type') }} :</span>
                    <span class="required">*</span>
                    <a-select
                        ref="select"
                        v-model:value="exportForm.exportType"
                        style="width: 291px;text-align:left"
                        allowClear
                        @change="handleExportTypeChange"
                    >
                        <a-select-option value="1">{{ $t('access.motor') }}</a-select-option>
                        <a-select-option value="2">{{ $t('access.battery') }}</a-select-option>
                        <a-select-option value="3">{{ $t('access.display') }}</a-select-option>
                        <a-select-option value="4">{{ $t('access.fault') }}</a-select-option>
                    </a-select>
                </div>
                <div class="exportFormItem">
                    <span class="exportLabel">{{ $t('access.date') }} :</span>
                    <span class="required">*</span>
                    <a-range-picker 
                        v-model:value="exportForm.dateRange" 
                        :disabled-date="disabledDate"
                        @change="onChange"
                        @openChange="onOpenChange"
                        @calendarChange="onCalendarChange"
                    />
                </div>
                <div class="exportFormItem exportActions">
                    <a-button type="primary" :loading="exportLoading" @click="confirmExportRawData">{{$t('base.export')}}</a-button>
                </div>
            </div>
        </a-modal>

        <!-- 日志、记录、设置列表弹窗 -->
        <div v-dialogDrag id="modalBox" v-if="modalVisible">
            <a-modal 
                v-model:open="modalVisible" 
                :title="modalTitle"
                centered
                :footer="null"
                :getContainer="getContainer"
                :force-render="true" 
                :width="modalWidth"
            >
                <div class="vehicleInfo" v-if="modalVisible">
                    <div>{{$t('access.frameNumber')}}：{{rowData.frame_number}}</div>
                    <div>{{$t('access.vehicle_name')}}：{{rowData.vehicle_name}}</div>
                    <div>{{$t('access.color')}}：{{rowData.color}}</div>
                    <!-- <div>{{$t('access.vehicle_status')}}：{{rowData.vehicle_status}}</div> -->
                    <div>{{$t('access.triple_id')}}：{{rowData.triple_id}}</div>
                </div>
                <!-- 日志标签页 -->
                <a-tabs v-if="logVisible" v-model:activeKey="logActiveKey" type="card"  @change="changeTab">
                    <a-tab-pane key="0" :tab="t('access.poweronLog')"></a-tab-pane>
                    <a-tab-pane key="1" :tab="t('access.upgradeLog')"></a-tab-pane>
                    <a-tab-pane key="2" :tab="t('access.upgradeTorqueLog')"></a-tab-pane>
                    <a-tab-pane key="3" :tab="t('access.replaceMotorErrorLog')"></a-tab-pane>
                    <a-tab-pane key="4" :tab="t('access.errorLog')"></a-tab-pane>
                    <a-tab-pane key="5" :tab="t('access.faultLog')"></a-tab-pane>
                    <a-tab-pane key="6" :tab="t('access.bluetoothLog')"></a-tab-pane>
                </a-tabs>
                <!-- BluetoothLog 日期范围筛选 -->
                <div v-if="logVisible && logActiveKey == '6'" class="ble-filter">
                    <a-range-picker
                        v-model:value="bleDateRange"
                        @change="onBleDateChange"
                    />
                </div>
                <!-- 日志 -->
                <Table
                    v-if="logVisible"
                    :table="logTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'log')"
                >
                    <template v-slot:customCol="{props}">
                        <template v-if="props.column.key === 'file_name'">
                            <div class="file_name" style="color:#1226aa;font-weight:600;cursor:pointer;text-decoration:underline" @click="handle('downLoad',props.record)">
                                {{props.record.file_name}}
                            </div>
                        </template>
                        <template v-if="props.column.key === 'operate' && logActiveKey == '6'">
                            <a-button type="primary" size="small" @click="handle('bleDownload', props.record)">
                                {{ $t('base.downLoad') }}
                            </a-button>
                        </template>
                    </template>
                </Table>
                <!-- 配置信息 -->
                <Table
                    ref="configInfoTableRef"
                    class="configInfoTable"
                    v-if="configInfoVisible"
                    :table="configInfoTable"
                >
                    <template v-slot:operateBtn>
                        <a-button 
                            v-if="configInfoVisible" 
                            style="margin-bottom:10px;margin-right:10px;"
                            type="primary"
                            size="small"
                            @click="addConfig"
                        >
                            <component :is="$antIcons['PlusCircleOutlined']" style="margin-top:2px;;fontSize:17px"></component>
                            {{ $t('access.addConfig') }}
                        </a-button>
                        <a-button 
                            v-if="configInfoVisible"
                            type="primary"
                            size="small"
                            @click="getVersion"
                        >
                            <component :is="$antIcons['ClockCircleOutlined']" style="margin-top:2px;fontSize:18px"></component>
                            {{ $t('access.historyVersion') }}
                        </a-button>
                    </template> 

                    <template v-slot:customCol="{props}">
                        <template v-if="props.column.key === 'config_name'">
                            <div v-if="props.record.edit">
                                <div>
                                    <i style="color:red">*</i> {{ $t('base.zh') }}: <a-input v-model:value="props.record.config_name" :maxlength="100" :disabled="props.record.disabled" style="margin:1px 0;width: 300px;height:25px;" />
                                </div>
                                <div>
                                    <i style="opacity:0">*</i> {{ $t('base.en') }}: <a-input v-model:value="props.record.config_name_en" :maxlength="100" :disabled="props.record.disabled" style="margin:1px 0;width: 300px;height:25px;" />
                                </div>
                                <div>
                                    <i style="opacity:0">*</i> {{ $t('base.de') }}: <a-input v-model:value="props.record.config_name_de" :maxlength="100" :disabled="props.record.disabled" style="margin:1px 0;width: 300px;height:25px;" />
                                </div>
                            </div>
                            <div v-if="!props.record.edit">
                                <div class="config_name">
                                    <a-tooltip placement="topLeft"> 
                                        <template #title>
                                            <span>{{ props.record.config_name }}</span>
                                        </template>  
                                        <span class="name_value">{{ props.record.config_name }}</span>
                                    </a-tooltip>
                                </div>
                            </div>
                        </template>
                        <template v-if="props.column.key === 'config_device'">
                            <a-select
                                v-if="props.record.edit"
                                ref="select"
                                v-model:value="props.record.config_device"
                                style="width: 90px"
                                :disabled="props.record.disabled"
                                :options="config_device_option"
                            ></a-select>
                            <span v-if="!props.record.edit">{{ props.record.config_device }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_item'">
                            <a-input 
                                v-if="props.record.edit" 
                                v-model:value="props.record.config_item"
                                :disabled="props.record.disabled"
                            />
                            <span v-if="!props.record.edit">{{ props.record.config_item }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_max'">
                            <a-input-number 
                                v-if="props.record.edit"
                                v-model:value="props.record.config_max" 
                                :min="props.record.config_min? props.record.config_min : 0" 
                                :disabled="props.record.disabled"
                            ></a-input-number>
                            <span v-if="!props.record.edit">{{ props.record.config_max }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_min'">
                            <a-input-number 
                                v-if="props.record.edit" 
                                v-model:value="props.record.config_min" 
                                :min="0" 
                                :max="props.record.config_max" 
                                :disabled="props.record.disabled || props.record.config_max === '' || props.record.config_max === null" 
                            ></a-input-number>
                            <span v-if="!props.record.edit">{{ props.record.config_min }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_value'">
                            <a-input-number 
                                v-if="props.record.edit" 
                                v-model:value="props.record.config_value" 
                                :disabled="props.record.disabled || props.record.config_max === '' || props.record.config_max === null || props.record.config_min === '' || props.record.config_min === null" 
                                @change="(val)=>changeInputNumber(val, props.record)"
                            ></a-input-number>
                            <span v-if="!props.record.edit">{{ props.record.config_value }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_size'">
                            <a-input-number
                                v-if="props.record.edit" 
                                v-model:value="props.record.config_size" 
                                :min="0" 
                                :disabled="props.record.disabled"
                            ></a-input-number>
                            <span v-if="!props.record.edit">{{ props.record.config_size }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_unit'">
                            <a-input
                                v-if="props.record.edit"   
                                v-model:value="props.record.config_unit" 
                                :disabled="props.record.disabled"
                            />
                            <span v-if="!props.record.edit">{{ props.record.config_unit }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_coefficient'">
                            <a-input-number
                                v-if="props.record.edit" 
                                v-model:value="props.record.config_coefficient" 
                                :min="0" 
                                :disabled="props.record.disabled"
                             ></a-input-number>
                            <span v-if="!props.record.edit">{{ props.record.config_coefficient }}</span>
                        </template>
                        <template v-if="props.column.key === 'config_encrypt'">
                            <a-select
                                v-if="props.record.edit" 
                                ref="select"
                                v-model:value="props.record.config_encrypt"
                                style="width: 90px"
                                :disabled="props.record.disabled"
                            >
                                <a-select-option :value="t('base.YES')">{{ $t('base.YES') }}</a-select-option>
                                <a-select-option :value="t('base.NO')">{{ $t('base.NO') }}</a-select-option>
                            </a-select>
                            <span v-if="!props.record.edit">{{ props.record.config_encrypt }}</span>
                        </template>
                        <template v-if="props.column.key === 'action'">
                            <a-button v-if="!props.record.edit" type="primary" size="small" :disabled="props.record.disabled || props.record.deleteItem" style="margin-right:10px" @click="handle('editItem',props.record)">
                                <a-tooltip placement="top">
                                    <template #title>
                                        <span>{{$t('base.edit')}}</span>
                                    </template>
                                    <component :is="$antIcons['EditOutlined']"></component>
                                </a-tooltip>
                            </a-button>
                            <a-button v-if="props.record.edit" type="primary" ghost success size="small" :disabled="props.record.disabled" style="margin-right:10px" @click="handle('finishItem',props.record)">
                               <a-tooltip placement="top">
                                    <template #title>
                                        <span> {{$t('base.finish')}}</span>
                                    </template>
                                    <component :is="$antIcons['CheckCircleOutlined']"></component>
                                </a-tooltip>
                            </a-button>
                            <a-button v-if="!props.record.deleteItem" type="primary" size="small" danger :disabled="props.record.disabled" @click="deleteConfigItem(props.record)">
                                <a-tooltip placement="top">
                                    <template #title>
                                        <span>{{$t('base.delete')}}</span>
                                    </template>
                                    <component :is="$antIcons['CloseCircleOutlined']"></component>
                                </a-tooltip>
                            </a-button>
                            <a-button v-if="props.record.deleteItem" size="small" :disabled="props.record.disabled" @click="revokeDeleteConfigItem(props.record)">
                                <a-tooltip placement="top">
                                    <template #title>
                                        <span>{{$t('base.revokeDelete')}}</span>
                                    </template>
                                    <component :is="$antIcons['RollbackOutlined']"></component>
                                </a-tooltip>
                            </a-button>
                        </template>
                    </template>
                </Table>
                <div style="text-align:center" v-if="showSave">
                    <a-button 
                        v-if="configInfoVisible" 
                        type="primary" 
                        style="margin-top:10px;width:10%"
                        @click="saveConfig"
                    >
                    <component :is="$antIcons['CheckOutlined']"></component>
                        {{ $t('base.confirm2') }}
                    </a-button>
                </div>
                <!-- 扭矩升级记录 -->
                <Table
                    v-if="torqueVisible"
                    :table="editTorqueTable"
                ></Table>
                <!-- 绑定记录 -->
                <Table
                    v-if="bindRecordVisible"
                    :table="bindRecordTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'bindRecord')"
                >
                    <template v-slot:customCol="{props}">
                        <template v-if="props.column.key === 'bind_email'">
                            {{ props.record.bind_email }}
                            <EyeInvisibleOutlined v-if="props.record.show_sensitive_bind_email && props.record.bind_email !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveData', props.record, 'bind_email')"/>
                            <EyeOutlined v-if="!props.record.show_sensitive_bind_email && props.record.bind_email !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveData', props.record, 'bind_email')"/>
                        </template>
                    </template>
                </Table>
                <!-- 申请替换电机记录 -->
                <Table
                    v-if="applyRecordVisible"
                    :table="applyReplaceMotorRecordTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'replaceMotorRecord')"
                >
                    <!-- <template v-slot:customCol="{props}">
                        <template v-if="props.column.key === 'status'">
                            <a-tag :color="props.record.status_val == 0? 'success' :props.record.status_val == 1? 'processing' : 'error'">{{props.record.status}}</a-tag>
                        </template>
                    </template> -->
                </Table>
                <!-- 当前设置 -->
                <Table
                    v-if="currentSettingVisible"
                    :table="currentSettingTable"
                ></Table>
                <!-- 上电信息 -->
                <Table
                    v-if="poweronInfoVisible"
                    :table="poweronInfoTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'poweronSession')"
                ></Table>
                <!-- Power-on position -->
                <Table
                    v-if="poweronPositionVisible"
                    :table="poweronPositionTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'poweronPosition')"
                ></Table>
                <!-- E-Bike setting -->
                <Table
                    v-if="ebikeSettingVisible"
                    :table="settingRecordTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'ebikeSetting')"
                >
                    <template v-slot:customCol="{props}">   
                        <template v-if="props.column.key === 'phone_key'">  
                            {{ props.record.phone_key }}
                            <EyeInvisibleOutlined v-if="props.record.show_sensitive_phone_key && props.record.phone_key !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveData', props.record, 'phone_key')"/>
                            <EyeOutlined v-if="!props.record.show_sensitive_phone_key && props.record.phone_key !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveData', props.record, 'phone_key')"/>
                        </template>
                        <template v-if="props.column.key === 'motor_key'">  
                            {{ props.record.motor_key }}
                            <EyeInvisibleOutlined v-if="props.record.show_sensitive_motor_key && props.record.motor_key !== '-'" style="float:right;margin-top:4px" @click="handle('showSensitiveData', props.record, 'motor_key')"/>
                            <EyeOutlined v-if="!props.record.show_sensitive_motor_key && props.record.motor_key !== '-'" style="float:right;margin-top:4px" @click="handle('hideSensitiveData', props.record, 'motor_key')"/>
                        </template>
                    </template>
                </Table>
                <!-- E-Bike repair records -->
                <Table
                    v-if="ebikeRepairVisible"
                    :table="repairRecordTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'ebikeRepair')"
                ></Table>
                <!-- E-Bike auth records -->
                <Table
                    v-if="ebikeAuthVisible"
                    :table="authRecordTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'ebikeAuth')"
                ></Table>
                <!-- Summary 汇总 -->
                <Table
                    v-if="summaryVisible"
                    :table="summaryTable"
                    @handleChangePagination="(config, data)=>handleChangePagination(config, data, 'summary')"
                ></Table>
            </a-modal>
        </div>

        <!-- 配置信息版本列表 -->
        <a-modal 
            v-model:open="versionVisible" 
            :title="t('access.versionTitle')"
            centered
            :footer="null"
            :force-render="true" 
            width="95%"
        >
            <a-collapse v-model:activeKey="versionActiveKey" accordion @change="changeCollapse">
                <a-collapse-panel v-for="(item,index) in versionList" :key="index">
                    <template v-slot:header>
                        <div class="versionHeader">
                            <div class="versionHeaderLeft" >
                                <div style="display:inline-block;margin-right:100px;"><span style="font-weight:600">{{ $t('access.versionDate') }}: </span>{{ item.create_timestamp}}</div>
                                <div style="display:inline-block;margin-right:100px;"><span style="font-weight:600">{{ $t('access.createTimestamp') }}: </span>{{ item.create_timestamp_val }}</div>
                                <div style="display:inline-block;"><span style="font-weight:600">{{ $t('access.creatorId') }}: </span>{{ item.create_id }}</div>    
                            </div>
                            <div class="versionHeaderRight" >
                                <a-button type="primary" size="small" @click.stop="rollBack(item)">{{$t('base.rollBack')}}</a-button>
                            </div>
                        </div>
                    </template>
                    <Table
                        class="versionTable"
                        v-if="versionVisible"
                        :table="versionTable"
                    >
                        <template v-slot:customCol="{props}">
                            <template v-if="props.column.key === 'config_name'">
                                <div class="config_name">
                                    <a-tooltip placement="topLeft"> 
                                        <template #title>
                                            <span>{{ props.record.config_name }}</span>
                                        </template>  
                                        <span class="name_value">{{ props.record.config_name }}</span>
                                    </a-tooltip>
                                </div>
                            </template>
                        </template>
                    </Table>
                    <a-divider>{{ $t('access.configChangeItem') }}</a-divider>
                    <Table
                        class="configChangeItemTable"
                        v-if="versionVisible"
                        :table="configChangeItemTable"
                    >
                        <template v-slot:customCol="{props}">
                            <template v-if="props.column.key === 'configName'">
                                <div class="config_name">
                                    <a-tooltip placement="topLeft"> 
                                        <template #title>
                                            <span>{{ props.record.configName }}</span>
                                        </template>  
                                        <span class="name_value">{{ props.record.configName }}</span>
                                    </a-tooltip>
                                </div>
                            </template>
                            <template v-if="props.column.key === 'category'">
                                <a-tag style="width:60px" :color="props.record.category_val === 0? 'orange' : props.record.category_val == 1? 'green' : 'red'">{{ props.record.category }}</a-tag>
                            </template>
                        </template>
                    </Table>
                </a-collapse-panel>
            </a-collapse>
            <div style="display:inline-block;margin-right:20px">
                {{ $t('base.total') }} {{ versionListTotal }} {{ $t('base.rows') }}
            </div>
            <a-button type="primary" size="small" style="margin:15px 15px 0 0" :disabled="versionPageNum == 1" @click="prevPage">
                <component :is="$antIcons['LeftOutlined']"></component>
            </a-button>
            <a-button type="primary" size="small" :disabled="versionPageNum == maxPageNum" @click="nextPage">
                <component :is="$antIcons['RightOutlined']"></component>
            </a-button>
        </a-modal>

        <!-- 更换电机时核对配置表信息 -->
        <a-modal 
            v-model:open="confirmConfigInfoVisible"
            :title="t('access.configInfoConfirm')"
            centered
            width="90%"
            :footer="null"
            style="text-align:center"
        >
                <Table
                    class="versionTable"
                    :table="confirmConfigInfoTable"
                >
                    <template v-slot:customCol="{props}">
                            <template v-if="props.column.key === 'config_name'">
                                <div class="config_name">
                                    <a-tooltip placement="topLeft"> 
                                        <template #title>
                                            <span>{{ props.record.config_name }}</span>
                                        </template>  
                                        <span class="name_value">{{ props.record.config_name }}</span>
                                    </a-tooltip>
                                </div>
                            </template>
                    </template>
                </Table>
                <div>
                    <a-button size="small" style="margin-top:15px; margin-right:10px;" @click="confirmConfigInfoVisible = false">
                        {{ t('base.cancel') }}
                    </a-button>
                    <a-button size="small" type="primary" style="margin-top:15px" @click="handle('configInfoConfirm')">
                        {{ t('base.confirm') }}
                    </a-button>
                </div>
        </a-modal>

        <!-- 选择更换电机，还是更新配置 -->
        <a-modal 
            v-model:open="selectReplaceItemVisible"
            :title="t('base.select')"
            centered
            width="30%"
            :footer="null"
            style="text-align:center"
        >
            <div style="padding:10px 0">
                <a-radio-group v-model:value="replace_motor_category">
                    <a-radio :value="1" style="margin-right:60px">{{ $t('access.applyReplaceMotor') }}</a-radio>
                    <a-radio :value="2">{{ $t('access.replaceConfig') }}</a-radio>
                </a-radio-group>
            </div>
            
            <a-divider style="margin:15px 0"></a-divider>
            <div style="margin-top:0px; text-align:center">
                <a-button type="primary" @click="handle('confirmReplace')">
                    {{ $t('base.confirm') }}
                </a-button>
            </div>
        </a-modal>

        <!-- Edit category -->
        <a-modal
            v-model:open="editCategoryVisible"
            :title="t('access.editCategory')"
            centered
            width="30%"
            :footer="null"
            style="text-align:center"
        >
            <div style="padding:10px 0">
                <a-radio-group v-model:value="editCategoryValue">
                    <a-radio :value="0" style="margin-right:60px">{{ $t('access.marketVehicle') }}</a-radio>
                    <a-radio :value="1">{{ $t('access.testVehicle') }}</a-radio>
                </a-radio-group>
            </div>
            <a-divider style="margin:15px 0"></a-divider>
            <div style="margin-top:0px; text-align:center">
                <a-button style="margin-right:10px" @click="editCategoryVisible=false">{{ $t('base.cancel') }}</a-button>
                <a-button type="primary" @click="handle('confirmEditCategory')">{{ $t('base.confirm') }}</a-button>
            </div>
        </a-modal>

        <!-- 人体工学调节 -->
        <a-modal
            v-model:open="skuVisible"
            centered
            :title="t('access.bindSKU')"
            :maskClosable="false"
            width="50%"
            @ok="handleSKU"
            @cancel="skuVisible = false"
        >
            <a-select 
                v-model:value="sku" 
                :options="skuOptions" 
                allowClear 
                style="width: 100%"
                show-search
                @search="fetchSKU"
                @focus="handleFocus"
            ></a-select>
        </a-modal>

        <!-- 车型是否支持人体工学调节 -->
        <a-modal
            v-model:open="mvpVisible"
            centered
            :title="t('access.editMVP')"
            :maskClosable="false"
            width="50%"
            @ok="handleMVP"
            @cancel="mvpVisible = false"
        >
            <a-select v-model:value="mvp" allowClear style="width: 100%">
                <a-select-option :value="0">{{ $t('base.yes') }}</a-select-option>
                <a-select-option :value="1">{{ $t('base.no') }}</a-select-option>
            </a-select>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, computed, createVNode, nextTick, watch} from "vue";
    import * as echarts from 'echarts'
    import 'echarts/extension/bmap/bmap';
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import QRCodeVue from 'qrcode.vue'
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { CyclingApi } from '@/api/CyclingApi.js';
    import { LoginApi } from '@/api/LoginApi.js';
    import { RoleApi } from '@/api/RoleApi.js';
    import { getCurDate, curDateTimestamp, timestampToDate, dateToTimestamp, getLastWeekDate, getFieldVal } from '@/utils/global';
    import { multiply, add, subtract, divide } from 'accurate-core';
    import { useDebounceFn } from '@vueuse/core';
    import { useStore } from '@/store/index.js'; 


    const route = useRoute()
    const router = useRouter()

    const store = useStore()
    const { t } = useI18n()

    const lang = ref(localStorage.getItem('lang'))
    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible = ref(false)
    const searchForm = reactive({
        frame_number: null,
        assembly_code: null,
        tenant_id:null,
        // email:'',
    })
    const rowData = ref(null)
    const frameNumberOptions = ref([])
    const motorCodeOptions = ref([])
    const tenantOptions = ref([])

    const replace_motor_category = ref('')
    const confirmConfigInfoVisible = ref(false)
    const selectReplaceItemVisible = ref(false)
    const showSave = ref(false)
    const frameNumber = ref('')
    const torque = ref('') 
    const editModalType = ref('')
    const fetching = ref(false)
    const showDeletePartBtn = ref(false)

    // 操作弹窗
    const modalVisible = ref(false)
    const editModalVisible = ref(false)
    const modalTitle = ref('')
    const modalWidth = ref('75%')
    const editModalTitle = ref('')
    const torqueUpdateVisible = ref(false)
    const configInfoVisible = ref(false)
    const torqueVisible = ref(false)
    const bindRecordVisible = ref(false)
    const versionVisible = ref(false)
    const applyRecordVisible = ref(false)
    const currentSettingVisible = ref(false)
    const poweronInfoVisible = ref(false)
    const logVisible = ref(false)
    const logActiveKey = ref('0')
    const summaryVisible = ref(false)
    const barcodeVisible = ref(false)
    const qrcodeVisible = ref(false)
    const barcodeUrl = ref('')
    const qrcodeUrl = ref('')

    // 新增视图控制与编辑分类状态
    const poweronPositionVisible = ref(false)
    const ebikeSettingVisible = ref(false)
    const ebikeRepairVisible = ref(false)
    const ebikeAuthVisible = ref(false)
    const editCategoryVisible = ref(false)
    const editCategoryValue = ref(null)

    const versionActiveKey = ref('0')
    const versionPageNum = ref(1)
    const versionPageSize = ref(10)
    const maxPageNum = ref(1)
    const versionListTotal = ref(0)
    const versionList = ref([])
    const dropMenuItemKeys = ref([])

    const skuVisible = ref(false)
    const mvpVisible = ref(false)
    const skuOptions = ref([])
    const sku = ref('')
    const mvp = ref('')
    const roleSupperAuth = import.meta.env.VITE_BASE_URL.trim() == 'https://sit.gobao-ebike.com' ? '252':(import.meta.env.VITE_BASE_URL.trim() == 'https://open.gobao-ebike.com' ? '38':'')

    const tableRef = ref(null)
    const config_device_option = ref([])
    const config_device_option_can = ref([
        {
            label:'EF',
            value:'EF',
        },
        {
            label:'F0',
            value:'F0',
        },
        {
            label:'28',
            value:'28',
        },
        {
            label:'F4',
            value:'F4',
        },
    ])
    const config_device_option_plc = ref([
        {
            label:'12',
            value:'12',
        },
        {
            label:'92',
            value:'92',
        },
        {
            label:'22',
            value:'22',
        },
        {
            label:'D2',
            value:'D2',
        },
    ])
       
    const headerData = ref({
        menu:'menu.AccessMTG',
        menu_desc: 'menu.subAccessMTG',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const dropdownMenu = ref([])
    
    const table = ref({
        data: [],
        columns: [
            {
                title: t('access.frameNumber'),
                dataIndex: 'frame_number',
                key: 'frame_number',
                width: 160,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('access.assemblyCode2'),
                dataIndex: 'triple_id',
                key: 'triple_id',
                width: 150,
                resizable: true,
            }, 
            {
                title: t('access.userEmail'),
                dataIndex: 'email',
                key: 'email',
                width: 220,
                resizable: true,
            },
            {
                title: t('access.phoneKey'),
                dataIndex: 'phone_key',
                key: 'phone_key',
                width: 150,
                resizable: true,
            },
            {
                title: t('access.motorKey'),
                dataIndex: 'motor_key',
                key: 'motor_key',
                width: 150,
                resizable: true,
            },
            {
                title: t('access.maximumTorque'),
                dataIndex: 'max_torque',
                key: 'max_torque',
                width: 160,
                resizable: true,
            }, 
            ...(userInfo.value.tenant_id != 1 ? [
                    {
                        title: t('access.wheelCircumference'),
                        dataIndex: 'wheel_circumference',
                        key: 'wheel_circumference',
                        width: 170,
                        resizable: true,
                    },
                ] : []
            ),
            ...(userInfo.value.tenant_id != 1 ? [
                {
                    title: t('access.maxSpeed'),
                    dataIndex: 'max_speed',
                    key: 'max_speed',
                    width: 140,
                    resizable: true,
                },
            ] : []),
            {
                title: t('access.motorChangeStatus'),
                dataIndex: 'motor_change_status',
                key: 'motor_change_status',
                width: 220,
                resizable: true,
            },
            {
                title: t('access.upgradeTorqueStatus'),
                dataIndex: 'upgrade_torque_status',
                key: 'upgrade_torque_status',
                width: 180,
                resizable: true,
            },
            ...(userInfo.value.tenant_id == 0 ? [
                {
                    title: t('access.sku'),
                    dataIndex: 'sku',
                    key: 'sku',
                    width: 160,
                    resizable: true,
                },
                {
                    title: t('access.mvp'),
                    dataIndex: 'mvp',
                    key: 'mvp',
                    width: 160,
                    resizable: true,
                },
                ] : []
            ),
            {
                title: t('access.category'),
                dataIndex: 'category',
                key: 'category',
                width: 160,
                resizable: true,
            },
            {
                title: t('access.user_category'),
                dataIndex: 'user_category',
                key: 'user_category',
                width: 160,
                resizable: true,
            },
            ...(userInfo.value.tenant_id == 1 ? [
                {
                    title: t('account.tenant'),
                    dataIndex: 'tenant_name',
                    key: 'tenant_name',
                    width: 140,
                    resizable: true,
                },
                {
                    title: t('access.protocol'),  // 协议
                    dataIndex: 'protocol',
                    key: 'protocol',
                    width:120,
                    resizable: true,
                },
                {
                    title: t('access.vehicleStatus'),  // 绑定状态
                    dataIndex: 'vehicle_status',
                    key: 'vehicle_status',
                    width:130,
                    resizable: true,
                },
                {
                    title: t('access.useMarkup'), // 使用状态
                    dataIndex: 'use_markup',
                    key: 'use_markup',
                    width:130,
                    resizable: true,
                },
                // {
                //     title: t('access.userIdentifier'), // 用户标识
                //     dataIndex: 'user_identifier',
                //     key: 'user_identifier',
                //     width:200,
                //     resizable: true,
                // },
            ] : []),
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: userInfo.value.tenant_id == 0? 320 : userInfo.value.tenant_id == 1 ? 420 : 270,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                // x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
        children:[{ // 子表格
            title:'',
            innerData:[],
            innerColumns:[
                {
                    title: t('access.partName'),//'部件名称'
                    dataIndex: 'part_name',
                    key: 'part_name',
                    // width: 150,
                    // resizable: true,
                },
                {
                    title: t('access.assemblyCode2'),//'总成编码'
                    dataIndex: 'assembly_no',
                    key: 'assembly_no',
                    // width: 150,
                    // resizable: true,
                },
                {
                    title: t('access.softwareVersion'),//'软件版本'
                    dataIndex: 'software_version',
                    key: 'software_version',
                    // width: 150,
                    // resizable: true,
                },
                {
                    title: t('access.hardwareVersion'),//'硬件版本'
                    dataIndex: 'hardware_version',
                    key: 'hardware_version',
                    // width: 150,
                    // resizable: true,
                },
                {
                    title: t('access.latestSoftwareVersion'),//'最新软件版本'
                    dataIndex: 'latest_software_version',
                    key: 'latest_software_version',
                    // width: 100,
                    // resizable: true,
                },
                {
                    title: t('base.operate'),//'操作'
                    key: 'action',
                    fixed: 'right',
                    width: 80,
                    // resizable: true,
                },
            ],
            innerConfigs: {
                table:{
                    rowClassName:(record, index)=>{ return 'subTableBg'}
                },
                rowSelection: false,
                loading: false,
                pagination: false,
                operateBtn: {
                    showSearch: true,
                    showAdd: false,
                }
            },
        }]
    })

    const upgradeTorqueStatusOptions = ref([
        {
            label:t('access.waiting'),
            value:1,
            disabled: true,
        },
        {
            label:t('access.cancel'),
            value:0,
            disabled: true,
        }
    ])

    const motorChangeStatusOptions = ref([
        {
            label:t('access.toBeReplace'),
            value:1,
            disabled: true,
        },
        {
            label:t('access.cancel'),
            value:0,
            disabled: true,
        }
    ])

    // 日志表格
    // 根据logActiveKey动态生成列
    const getLogColumns = (activeKey) => {
        // Bluetooth log: show circled fields only
        if(activeKey == 6){
            return [
                {
                    title: t('base.order_number'),
                    dataIndex: 'order_number',
                    key: 'order_number',
                    width: 60,
                },
                {
                    title: t('access.app_version'),
                    dataIndex: 'app_version',
                    key: 'app_version',
                    width: 190,
                },
                {
                    title: t('access.device_system'),
                    dataIndex: 'device_system',
                    key: 'device_system',
                    width: 190,
                },
                {
                    title: t('access.upload_time'),
                    dataIndex: 'upload_timestamp',
                    key: 'upload_timestamp',
                    width: 180,
                },
                // {
                //     title: t('access.end_time'),
                //     dataIndex: 'end_timestamp',
                //     key: 'end_timestamp',
                //     width: 180,
                // },
                {
                    title: t('access.file_no'),
                    dataIndex: 'file_no',
                    key: 'file_no',
                    width: 220,
                },
                {
                    title: t('base.operate'),
                    key: 'operate',
                    width: 140,
                    customRender: ({ record }) => {
                        return ''
                    },
                },
            ]
        }

        return [
            {
                title: t('base.order_number'),  // 序号
                dataIndex: 'order_number',
                key: 'order_number',
                width: 60,
            },
            ...(activeKey != 3 ? [
                {
                    title: t('access.poweron_no'),  // 上电编号
                    dataIndex: 'ride_no',
                    key: 'ride_no',
                    width: 120,
                },
            ] : []),

            ...(activeKey != 4 ? [
                {
                    title: t('access.app_version'),  // App版本
                    dataIndex: 'app_version',
                    key: 'app_version',
                    width: 190,
                },
            ] : []),

            ...(activeKey != 5 ? [
                {
                    title: t('access.part_no'), // 部件编号
                    dataIndex: 'part_no',
                    key: 'part_no',
                    width: 100,
                },
            ] : []),

            ...(activeKey != 4 && activeKey != 5 ? [
                {
                    title: t('access.assembly_no'), // 总成编码
                    dataIndex: 'assembly_no',
                    key: 'assembly_no',
                    width: 150,
                },
                {
                    title: t('access.project_no'), // 项目信息
                    dataIndex: 'project_no',
                    key: 'project_no',
                    width: 140,
                },
            ] : []),

            ...(activeKey == 0 ? [
                {
                    title: t('access.poweron_time'), // 上电时间
                    dataIndex: 'upgrade_time',
                    key: 'upgrade_time',
                    width: 150,
                },
            ] : []),

            ...(activeKey != 0 && activeKey != 4 && activeKey != 5 ? [   // 升级、升级扭矩日志
                {
                    title: t('access.upgrade_time'), // 升级/更换时间
                    dataIndex: 'upgrade_time',
                    key: 'upgrade_time',
                    width: 180,
                },
                {
                    title: t('access.upgrade_excep'), // 升级失败项
                    dataIndex: 'upgrade_excep',
                    key: 'upgrade_excep',
                    width: 300,
                },
            ] : []),

            ...(activeKey != 4 && activeKey != 5 ? [
                {
                    title: t('access.hardware_version'), // 硬件版本
                    dataIndex: 'hardware_version',
                    key: 'hardware_version',
                    width: 150,
                },
                {
                    title: t('access.software_version'), // 软件版本
                    dataIndex: 'software_version',
                    key: 'software_version',
                    width: 150,
                },
            ] : []),

            ...(activeKey != 0 && activeKey != 4 && activeKey != 5 ? [
                {
                    title: t('access.init_software_version'),  // 初始软件版本
                    dataIndex: 'init_software_version',
                    key: 'init_software_version',
                    width: 180,
                },
            ] : []),
            ...(activeKey != 0 && activeKey != 5 ? [
                {
                    title: t('access.start_timestamp'), // 开始日期时间戳
                    dataIndex: 'start_timestamp',
                    key: 'start_timestamp',
                    width: 150,
                },
                {
                    title: t('access.end_timestamp'), // 结束日期时间戳
                    dataIndex: 'end_timestamp',
                    key: 'end_timestamp',
                    width: 150,
                },
            ] : []),

            ...(activeKey == 4 ? [
                {
                    title: t('access.log_file'), // 错误日志文件
                    dataIndex: 'file_name',
                    key: 'file_name',
                    width: 100,
                },
            ] : []),

            ...(activeKey == 5 ? [
                {
                    title: t('access.fault_code'), // 故障码
                    dataIndex: 'fault_code',
                    key: 'fault_code',
                    width: 130,
                },
                {
                    title: t('access.fault_parse_plaintext'), // 故障名称
                    dataIndex: 'fault_parse_plaintext',
                    key: 'fault_parse_plaintext',
                    width: 130,
                },
                {
                    title: t('access.distance'), // 骑行距离
                    dataIndex: 'distance',
                    key: 'distance',
                    width: 130,
                },
                {
                    title: t('access.occur_timestamp'), // 时间戳
                    dataIndex: 'occur_timestamp',
                    key: 'occur_timestamp',
                    width: 130,
                },
            ] : []),
        ]
    }

    const logTable = ref({
        data: [],
        columns: getLogColumns(logActiveKey.value),
        configs: {
            table: {},
            scroll: {
                // x: 1400,
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination: {
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${logTable.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 参数配置信息表格
    const configInfoTableRef = ref(null)
    const configInfoTable = ref({
        data: [],
        columns: [
            {
                title: '#', // 序号
                dataIndex: 'serial',
                key: 'serial',
                width: 50,
            },
            {
                title: t('access.config_name'), // 配置名称
                dataIndex: 'config_name',
                key: 'config_name',
                width: 370,
            },
            {
                title: t('access.config_device'), // 配置设备
                dataIndex: 'config_device',
                key: 'config_device',
                width: 120,
            },
            {
                title: t('access.config_item'), // 配置项
                dataIndex: 'config_item',
                key: 'config_item',
                width: 120,
            },
            {
                title: t('access.config_max'), // 配置最大值
                dataIndex: 'config_max',
                key: 'config_max',
                width: 100,
            },
            {
                title: t('access.config_min'), // 配置最小值
                dataIndex: 'config_min',
                key: 'config_min',
                width: 100,
            },
            {
                title: t('access.config_value'), // 配置数值
                dataIndex: 'config_value',
                key: 'config_value',
                width: 100,
            },
            {
                title: t('access.config_size'), // 配置大小
                dataIndex: 'config_size',
                key: 'config_size',
                width: 100,
            },
            {
                title: t('access.config_unit'), // 配置单位
                dataIndex: 'config_unit',
                key: 'config_unit',
                width: 100,
            },
            {
                title: t('access.config_coefficient'), // 配置系数
                dataIndex: 'config_coefficient',
                key: 'config_coefficient',
                width: 120,
            },
            {
                title: t('access.config_encrypt'), // 配置是否加密
                dataIndex: 'config_encrypt',
                key: 'config_encrypt',
                width: 100,
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 130, //lang.value == 'zh' ? 100 : 265,
                resizable: true,
            },
        ],
        configs: {
            table: {
                rowClassName:null,
            },
            scroll: {
                x: 800,//设置表格宽度
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            },
        },
    })

    // 配置信息版本列表
    const versionTable = ref({
        data: [],
        columns: [
            {
                title: t('access.config_name'), // 配置名称
                dataIndex: 'config_name',
                key: 'config_name',
                width: 350,
                // ellipsis:true,
            },
            {
                title: t('access.config_device'), // 配置设备
                dataIndex: 'config_device',
                key: 'config_device',
            },
            {
                title: t('access.config_item'), // 配置项
                dataIndex: 'config_item',
                key: 'config_item',
            },
            {
                title: t('access.config_value'), // 配置数值
                dataIndex: 'config_value',
                key: 'config_value',
            },
            {
                title: t('access.config_max'), // 配置最大值
                dataIndex: 'config_max',
                key: 'config_max',
            },
            {
                title: t('access.config_min'), // 配置最小值
                dataIndex: 'config_min',
                key: 'config_min',
            },
            
            {
                title: t('access.config_size'), // 配置大小
                dataIndex: 'config_size',
                key: 'config_size',
            },
            {
                title: t('access.config_unit'), // 配置单位
                dataIndex: 'config_unit',
                key: 'config_unit',
            },
            {
                title: t('access.config_coefficient'), // 配置系数
                dataIndex: 'config_coefficient',
                key: 'config_coefficient',
            },
            {
                title: t('access.config_encrypt'), // 配置是否加密
                dataIndex: 'config_encrypt',
                key: 'config_encrypt',
            },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,//设置表格宽度
                y: 250,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 配置变更项
    const configChangeItemTable = ref({
        data: [],
        columns: [
            {
                title: t('access.config_name'), // 配置名称
                dataIndex: 'configName',
                key: 'configName',
                width: 350,
            },
            {
                title: t('access.config_item'), // 配置项
                dataIndex: 'configItem',
                key: 'configItem',
            },
            {
                title: t('access.config_old_value'), // 配置旧值
                dataIndex: 'configOldValue',
                key: 'configOldValue',
            },
            {
                title: t('access.config_new_value'), // 配置新值
                dataIndex: 'configNewValue',
                key: 'configNewValue',
            },
            {
                title: t('access.category'), // 变更类别
                dataIndex: 'category',
                key: 'category',
            },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,//设置表格宽度
                y: 250,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 确认配置信息列表
    const confirmConfigInfoTable = ref({
        data: [],
        columns: [
            {
                title: t('access.config_name'), // 配置名称
                dataIndex: 'config_name',
                key: 'config_name',
                width: 350,
            },
            {
                title: t('access.config_device'), // 配置设备
                dataIndex: 'config_device',
                key: 'config_device',
            },
            {
                title: t('access.config_item'), // 配置项
                dataIndex: 'config_item',
                key: 'config_item',
            },
            {
                title: t('access.config_value'), // 配置数值
                dataIndex: 'config_value',
                key: 'config_value',
            },
            {
                title: t('access.config_max'), // 配置最大值
                dataIndex: 'config_max',
                key: 'config_max',
            },
            {
                title: t('access.config_min'), // 配置最小值
                dataIndex: 'config_min',
                key: 'config_min',
            },
            
            {
                title: t('access.config_size'), // 配置大小
                dataIndex: 'config_size',
                key: 'config_size',
            },
            {
                title: t('access.config_unit'), // 配置单位
                dataIndex: 'config_unit',
                key: 'config_unit',
            },
            {
                title: t('access.config_coefficient'), // 配置系数
                dataIndex: 'config_coefficient',
                key: 'config_coefficient',
            },
            {
                title: t('access.config_encrypt'), // 配置是否加密
                dataIndex: 'config_encrypt',
                key: 'config_encrypt',
            },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,//设置表格宽度
                y: 500,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 升级扭矩记录
    const editTorqueTable = ref({
        data: [],
        columns: [
            {
                title: t('access.init_torque'), // 初始扭矩
                dataIndex: 'init_torque',
                key: 'init_torque',
            },
            {
                title: t('access.target_torque'), // 目标扭矩
                dataIndex: 'target_torque',
                key: 'target_torque',
            },
            {
                title: t('access.status'), // 状态
                dataIndex: 'status',
                key: 'status',
            },
            {
                title: t('access.create_time'), // 创建时间
                dataIndex: 'create_timestamp',
                key: 'create_timestamp',
                width:200,
            },
            {
                title: t('access.cancel_time'), // 取消时间
                dataIndex: 'cancel_timestamp',
                key: 'cancel_timestamp',
                width:180,
            },
            {
                title: t('access.finish_time'), // 升级完成时间
                dataIndex: 'change_timestamp',
                key: 'change_timestamp',
                width:180,
            },
            // {
            //     title: t('base.operate'),//'操作'
            //     key: 'action',
            //     fixed: 'right',
            //     width: lang.value == 'zh' ? 200 : 240,
            //     resizable: true,
            // },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,//设置表格宽度
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 绑定记录
    const bindRecordTable = ref({
        data: [],
        columns: [
            {
                title: t('access.bind_email'), // 绑定邮箱
                dataIndex: 'bind_email',
                key: 'bind_email',
                width: 100,
            },
            {
                title: t('access.bind_time'), // 绑定时间
                dataIndex: 'bind_timestamp',
                key: 'bind_timestamp',
                width: 120,
            },
            {
                title: t('access.bind_category'), // 绑定状态
                dataIndex: 'bind_category',
                key: 'bind_category',
                width: 100,
            },
            // {
            //     title: t('access.bind_mode_category'), // 绑定类型
            //     dataIndex: 'bind_mode_category',
            //     key: 'bind_mode_category',
            //     width: 120,
            // },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,//设置表格宽度
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${bindRecordTable.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 申请更换电机记录
    const applyReplaceMotorRecordTable = ref({
        data: [],
        columns: [
            {
                title: t('access.cycling_mileage'), // 骑行里程
                dataIndex: 'cycling_mileage',
                key: 'cycling_mileage',
                width: 150,
            },
            {
                title: t('access.init_triple_id'), // 初始三合一ID
                dataIndex: 'init_triple_id',
                key: 'init_triple_id',
                width: 150,
            },
            {
                title: t('access.target_triple_id'), // 目标三合一ID
                dataIndex: 'target_triple_id',
                key: 'target_triple_id',
                width: 160,
            },
            {
                title: t('access.apply_status'), //  更换状态
                dataIndex: 'status',
                key: 'status',
                width: 180,
            },
            {
                title: t('access.replace_category'), //  更换类型
                dataIndex: 'category',
                key: 'category',
                width: 180,
            },
            {
                title: t('access.channel'), //  更换渠道
                dataIndex: 'platform',
                key: 'platform',
                width: 180,
            },
            {
                title: t('access.apply_create_time'), // 更换日期
                dataIndex: 'create_timestamp',
                key: 'create_timestamp',
                width: 180,
            },
            {
                title: t('access.finish_time'), // 完成日期
                dataIndex: 'change_timestamp',
                key: 'change_timestamp',
                width: 180,
            },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,//设置表格宽度
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${applyReplaceMotorRecordTable.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 当前设置
    const currentSettingTable = ref({
        data: [],
        columns: [
            {
                title: t('access.assist_level'), // 助力等级
                dataIndex: 'assist_level',
                key: 'assist_level',
                width: 130,
            },
            {
                title: t('access.maximum_torque'), // 扭矩
                dataIndex: 'maximum_torque',
                key: 'maximum_torque',
                width: 150,
            },
            {
                title: t('access.mode'), // 档位
                dataIndex: 'mode',
                key: 'mode',
                width: 80,
            },
            {
                title: t('access.trolley_speed'), // 推车速度
                dataIndex: 'trolley_speed',
                key: 'trolley_speed',
                width: 150,
            },
            {
                title: t('access.recognition_sensitivity'), // 敏感识别度
                dataIndex: 'recognition_sensitivity',
                key: 'recognition_sensitivity',
                width: 180,
            },
            {
                title: t('access.start_response'), // 回复响应
                dataIndex: 'start_response',
                key: 'start_response',
                width: 120,
            },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,//设置表格宽度
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:false,
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // 上电信息
    const poweronInfoTable = ref({
        data: [],
        columns: [
            {
                title: t('access.ride_no'), // 上电编号
                dataIndex: 'ride_no',
                key: 'ride_no',
                width: 100,
            },
            {
                title: t('access.distance'), // 距离
                dataIndex: 'distance',
                key: 'distance',
                width: 120,
            },
            {
                title: t('access.cost_time'), // 用时
                dataIndex: 'cost_time',
                key: 'cost_time',
                width: 160,
            },
            {
                title: t('access.average_speed'), //  平均速度
                dataIndex: 'average_speed',
                key: 'average_speed',
                width: 180,
            },
            {
                title: t('access.highest_speed'), // 最高速度
                dataIndex: 'highest_speed',
                key: 'highest_speed',
                width: 180,
            },
            {
                title: t('access.power_consumption'), // 用电量
                dataIndex: 'power_consumption',
                key: 'power_consumption',
                width: 180,
            },
            {
                title: t('access.eco_mode'), // eco_mode
                dataIndex: 'eco_mode',
                key: 'eco_mode',
                width: 100,
            },
            {
                title: t('access.off_mode'), // off_mode
                dataIndex: 'off_mode',
                key: 'off_mode',
                width: 100,
            },
            {
                title: t('access.tour_mode'), // tour_mode
                dataIndex: 'tour_mode',
                key: 'tour_mode',
                width: 110,
            },
            {
                title: t('access.turbo_mode'), // turbo_mode
                dataIndex: 'turbo_mode',
                key: 'turbo_mode',
                width: 110,
            },
            {
                title: t('access.boost_mode'), // boost_mode
                dataIndex: 'boost_mode',
                key: 'boost_mode',
                width: 110,
            },
            {
                title: t('access.auto_mode'), // auto_mode
                dataIndex: 'auto_mode',
                key: 'auto_mode',
                width: 110,
            },
            {
                title: t('access.ride_date'), // 日期
                dataIndex: 'ride_date',
                key: 'ride_date',
                width:180,
                resizable: true,
            },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,
                y: 450,
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${poweronInfoTable.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // Power-on position
    const poweronPositionTable = ref({
        data: [],
        columns: [
            { title: t('access.userID'), dataIndex: 'user_id', key: 'user_id', width: 100 },
            { title: t('access.appVersion'), dataIndex: 'app_version', key: 'app_version', width: 120 },
            { title: t('access.rideNo'), dataIndex: 'ride_no', key: 'ride_no', width: 100 },
            { title: t('access.longitude'), dataIndex: 'longitude', key: 'longitude', width: 120 },
            { title: t('access.latitude'), dataIndex: 'latitude', key: 'latitude', width: 120 },
            { title: t('access.elevation'), dataIndex: 'elevation', key: 'elevation', width: 120 },
            { title: t('access.reportCategory'), dataIndex: 'report_category', key: 'report_category', width: 150 },
            { title: t('access.reportTime'), dataIndex: 'report_time', key: 'report_time', width: 200 },
        ],
        configs: {
            table: {},
            scroll: { x: 800, y: 450 },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${poweronPositionTable.value.configs.pagination.total} ` + t('base.row'),
            },
            operateBtn: { showSearch: false, showAdd: false }
        },
    })

    // Setting records
    const settingRecordTable = ref({
        data: [],
        columns: [
            { title: t('access.poweron_no'), dataIndex: 'ride_no', key: 'ride_no', width: 120 },
            { title: t('access.autoLight'), dataIndex: 'auto_light', key: 'auto_light', width: 100 },
            { title: t('access.beeper'), dataIndex: 'beeper', key: 'beeper', width: 90 },
            { title: t('access.language'), dataIndex: 'language', key: 'language', width: 100 },
            { title: t('access.lowBattery'), dataIndex: 'low_battery', key: 'low_battery', width: 120 },
            { title: t('access.phoneKey'), dataIndex: 'phone_key', key: 'phone_key', width: 100 },
            { title: t('access.motorKey'), dataIndex: 'motor_key', key: 'motor_key', width: 100 },
            { title: t('access.units'), dataIndex: 'units', key: 'units', width: 80 },
            { title: t('access.assistLevel'), dataIndex: 'assist_level', key: 'assist_level', width: 130 },
            { title: t('access.maximumTorque'), dataIndex: 'maximum_torque', key: 'maximum_torque', width: 150 },
            { title: t('access.mode'), dataIndex: 'mode', key: 'mode', width: 80 },
            { title: t('access.wheelDiameter'), dataIndex: 'wheel_diameter', key: 'wheel_diameter', width: 150 },
            { title: t('access.trolleySpeed'), dataIndex: 'trolley_speed', key: 'trolley_speed', width: 120 },
            { title: t('access.recognitionSensitivity'), dataIndex: 'recognition_sensitivity', key: 'recognition_sensitivity', width: 180 },
            { title: t('access.startResponse'), dataIndex: 'start_response', key: 'start_response', width: 150 },
            { title: t('access.settingTime'), dataIndex: 'setting_time', key: 'setting_time', width: 220 },
        ],
        configs: {
            table: {},
            scroll: { x: 800, y: 450 },
            rowSelection: false,
            loading: false,
            pagination:{ hideOnSinglePage:false, position:['bottomLeft'], responsive:true, current:1, pageSize:10, pageSizeOptions:['10','20','50'], total:0, showTotal:()=>t('base.total') + ` ${settingRecordTable.value.configs.pagination.total} ` + t('base.row') },
            operateBtn: { showSearch: false, showAdd: false }
        },
    })

    // Repair records
    const repairRecordTable = ref({
        data: [],
        columns: [
            { title: t('access.repairCategory'), dataIndex: 'category', key: 'category', width: 150 },
            { title: t('access.mesSync'), dataIndex: 'mes_sync', key: 'mes_sync', width: 120 },
            { title: t('access.repairStartTime'), dataIndex: 'repair_start_time', key: 'repair_start_time', width: 160 },
            { title: t('access.repairEndTime'), dataIndex: 'repair_end_time', key: 'repair_end_time', width: 180 },
            { title: t('access.repairStatus'), dataIndex: 'status', key: 'status', width: 180 },
        ],
        configs: {
            table: {},
            scroll: { x: 800, y: 450 },
            rowSelection: false,
            loading: false,
            pagination:{ hideOnSinglePage:false, position:['bottomLeft'], responsive:true, current:1, pageSize:10, pageSizeOptions:['10','20','50'], total:0, showTotal:()=>t('base.total') + ` ${repairRecordTable.value.configs.pagination.total} ` + t('base.row') },
            operateBtn: { showSearch: false, showAdd: false }
        },
    })

    // Auth records
    const authRecordTable = ref({
        data: [],
        columns: [
            { title: t('access.appVersion'), dataIndex: 'app_version', key: 'app_version', width: 120 },
            { title: t('access.poweron_no'), dataIndex: 'ride_no', key: 'ride_no', width: 120 },
            { title: t('access.startTimestamp'), dataIndex: 'start_timestamp', key: 'start_timestamp', width: 150 },
            { title: t('access.endTimestamp'), dataIndex: 'end_timestamp', key: 'end_timestamp', width: 150 },
            { title: t('access.startDate'), dataIndex: 'start_date', key: 'start_date', width: 150 },
            { title: t('access.endDate'), dataIndex: 'end_date', key: 'end_date', width: 150 },
            { title: t('access.authResult'), dataIndex: 'auth_result', key: 'auth_result', width: 120 },
            { title: t('access.authDesc'), dataIndex: 'auth_desc', key: 'auth_desc', width: 150 },
            { title: t('access.secretKey'), dataIndex: 'secret_key', key: 'secret_key', width: 170 },
            { title: t('access.authTime'), dataIndex: 'auth_time', key: 'auth_time', width: 120 },
        ],
        configs: {
            table: {},
            scroll: { x: 800, y: 450 },
            rowSelection: false,
            loading: false,
            pagination:{ hideOnSinglePage:false, position:['bottomLeft'], responsive:true, current:1, pageSize:10, pageSizeOptions:['10','20','50'], total:0, showTotal:()=>t('base.total') + ` ${authRecordTable.value.configs.pagination.total} ` + t('base.row') },
            operateBtn: { showSearch: false, showAdd: false }
        },
    })

    // Summary 汇总
    const summaryTable = ref({
        data: [],
        columns: [
            {
                title: t('access.ride_no'),
                dataIndex: 'ride_no',
                key: 'ride_no',
                width: 100,
            },
            {
                title: t('access.cycling_mileage'),
                dataIndex: 'cycling_mileage',
                key: 'cycling_mileage',
                width: 140,
            },
            {
                title: t('access.cadance'),
                dataIndex: 'cadence',
                key: 'cadence',
                width: 120,
            },
            {
                title: t('access.assemblyCode'),
                dataIndex: 'triple_id',
                key: 'triple_id',
                width: 140,
            },
            {
                title: 'ECU',
                dataIndex: 'ecu_software_version',
                key: 'ecu_software_version',
                width: 120,
            },
            {
                title: 'BMS',
                dataIndex: 'bms_software_version',
                key: 'bms_software_version',
                width: 120,
            },
            {
                title: 'CCU',
                dataIndex: 'ccu_software_version',
                key: 'ccu_software_version',
                width: 120,
            },
            {
                title: t('access.meter'),
                dataIndex: 'meter_software_version',
                key: 'meter_software_version',
                width: 140,
            },
            {
                title: t('access.ride_timestamp'),
                dataIndex: 'ride_timestamp',
                key: 'ride_timestamp',
                width: 140,
            },
        ],
        configs: {
            table: {},
            scroll: {
                x: 800,
                y: 450,
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${summaryTable.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // plc 扭矩
    const plc_max_torqueOptions = ref([ 
        {
            value:'80 Nm',
            label:'80 Nm',
            disabled:false,
            key:'8000',
        },
        {
            value:'85 Nm',
            label:'85 Nm',
            disabled:false,
            key:'8500',
        },
        {
            value:'90 Nm',
            label:'90 Nm',
            disabled:false,
            key:'9000',
        },
        {
            value:'95 Nm',
            label:'95 Nm',  
            disabled:false,
            key:'9500',
        },
        {
            value:'100 Nm',
            label:'100 Nm',
            disabled:false,
            key:'10000',
        },
        {
            value:'110 Nm',
            label:'110 Nm',
            disabled:false,
            key:'11000',
        },
        // {
        //     value:'120 Nm',
        //     label:'120 Nm',
        //     disabled:false,
        //     key:'12000',
        // },
    ])
    
    // can 扭矩
    const can_max_torqueOptions = ref([ 
        ...(userInfo.value.tenant_id == 1 ? [
            {
                value:'50 Nm',
                label:'50 Nm',
                disabled:false,
                key:'5000',
            },{
                value:'55 Nm',
                label:'55 Nm',
                disabled:false,
                key:'5500',
            },{
                value:'60 Nm',
                label:'60 Nm',
                disabled:false,
                key:'6000',
            }] : []
        ),
        {
            value:'65 Nm',
            label:'65 Nm',
            disabled:false,
            key:'6500',
        },
        {
            value:'70 Nm',
            label:'70 Nm',
            disabled:false,
            key:'7000',
        },
        {
            value:'75 Nm',
            label:'75 Nm',
            disabled:false,
            key:'7500',
        },
        {
            value:'80 Nm',
            label:'80 Nm',
            disabled:false,
            key:'8000',
        },
        {
            value:'85 Nm',
            label:'85 Nm',
            disabled:false,
            key:'8500',
        },
        {
            value:'90 Nm',
            label:'90 Nm',
            disabled:false,
            key:'9000',
        },
        {
            value:'95 Nm',
            label:'95 Nm',
            disabled:false,
            key:'9500',
        },
        {
            value:'100 Nm',
            label:'100 Nm',
            disabled:false,
            key:'10000',
        },
        {
            value:'110 Nm',
            label:'110 Nm',
            disabled:false,
            key:'11000',
        },
        // {
        //     value:'120 Nm',
        //     label:'120 Nm',
        //     disabled:false,
        //     key:'12000',
        // },
    ])

    const getContainer = () => {
        return document.getElementById('modalBox');
    }

    // 表格分页
    const handleChangePagination = (config, data, type)=> {
        console.log(config, data, type,'config, data, type')
        switch(type){
            case 'bikeList': // 车辆信息列表分页
                table.value.configs.pagination.current = config.current
                table.value.configs.pagination.pageSize = config.pageSize
                getVehicleList()
                break;
            case 'summary': // 汇总分页
                summaryTable.value.configs.pagination.current = config.current
                summaryTable.value.configs.pagination.pageSize = config.pageSize
                getSummeryData(rowData.value)
                break;
            case 'bindRecord': // 绑定记录分页
                bindRecordTable.value.configs.pagination.current = config.current
                bindRecordTable.value.configs.pagination.pageSize = config.pageSize
                getBindRecordList(rowData.value)
                break;
            case 'replaceMotorRecord': // 更换电机记录分页
                applyReplaceMotorRecordTable.value.configs.pagination.current = config.current
                applyReplaceMotorRecordTable.value.configs.pagination.pageSize = config.pageSize
                motorReplaceRecord(rowData.value.id)
                break;
            case 'poweronSession': // 上电信息
                poweronInfoTable.value.configs.pagination.current = config.current
                poweronInfoTable.value.configs.pagination.pageSize = config.pageSize
                getSeriesList(rowData.value)
                break;
            case 'log': // 日志分页
                logTable.value.configs.pagination.current = config.current
                logTable.value.configs.pagination.pageSize = config.pageSize
                if(logActiveKey.value == '5'){
                    getFaultLog(rowData.value)
                }else{
                    getLogList(rowData.value)
                }
                break;
            case 'poweronPosition': // 上电位置
                poweronPositionTable.value.configs.pagination.current = config.current
                poweronPositionTable.value.configs.pagination.pageSize = config.pageSize
                getPoweronPositionList(rowData.value)
                break;
            case 'ebikeSetting': // 设置记录
                settingRecordTable.value.configs.pagination.current = config.current
                settingRecordTable.value.configs.pagination.pageSize = config.pageSize
                getSettingRecordList(rowData.value)
                break;
            case 'ebikeRepair': // 维修记录
                repairRecordTable.value.configs.pagination.current = config.current
                repairRecordTable.value.configs.pagination.pageSize = config.pageSize
                getRepairRecordList(rowData.value)
                break;
            case 'ebikeAuth': // 鉴权记录
                authRecordTable.value.configs.pagination.current = config.current
                authRecordTable.value.configs.pagination.pageSize = config.pageSize
                getAuthRecordList(rowData.value)
                break;

        }
    }

    const handle = async (type, row, key)=>{
        switch(type){
            case 'torqueUpgrade': // 扭矩升级
                torqueUpdateVisible.value = true
                rowData.value = row
                console.log(row.max_torque, 'row.max_torque')
                torque.value = row.max_torque == '-' ? '' : row.max_torque
                break;
            case 'unbindUser': // 解绑用户
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('access.unbindBikeUserConfirmMsg'),
                    okText: t('base.confirm'),
                    cancelText: t('base.cancel'),
                    onOk() {
                        unbindUser(row)
                    },
                })
                break;
            case 'motorReplace': // 更换电机
                if(userInfo.value.tenant_id == 1){
                    rowData.value = row
                    selectReplaceItemVisible.value = true
                    replace_motor_category.value = ''
                }else{ // 普通租户不支持 更新配置
                    Modal.confirm({
                        title: t('base.tip'),
                        content: t('access.replaceMotorTip'),
                        okText: t('base.confirm'),
                        cancelText: t('base.cancel'),
                        onOk() {
                            applyReplaceMotor(row.id)
                        },
                    });
                }
                break;
            case 'confirmReplace': // 确认更换电机
                if(!replace_motor_category.value){
                    message.error(t('base.select'))
                    return
                }
                selectReplaceItemVisible.value = false
                applyReplaceMotor(rowData.value.id)
                break;
            case 'bleDownload': // Bluetooth 日志文件下载
                if(!row || !row.file_no || row.file_no === '-'){
                    message.error(t('base.error'))
                    return
                }
                try{
                    message.info(t('base.downloading'))
                    let res = await AdvancedFunApi.getInstance().downloadBluetoothFile(row.file_no)
                    if(!res.code){
                        let blob = new Blob([res.data])
                        let a = document.createElement('a')
                        a.href = URL.createObjectURL(blob)
                        a.download = `${row.file_no}.log`
                        a.click()
                        URL.revokeObjectURL(a.href)
                        message.success(t('base.downloadSucceeded'))
                    }else if(res.code == 1273){
                        Modal.info({
                            title: t('base.tip'),
                            content: res?.msg || t('base.downloadFailed'),
                        })
                    }else{
                        Modal.error({
                            title: t('base.tip'),
                            content: res?.msg || t('base.downloadFailed'),
                        }) 
                    }
                }catch(e){
                    message.error(t('base.downloadFailed'))
                }
                break;
            case 'paramConfig': // 配置信息
                resetVisible()
                configInfoVisible.value = true
                modalVisible.value  = true
                modalTitle.value = t('access.configInfo')
                modalWidth.value = '95%'
                frameNumber.value = row.frame_number
                rowData.value = row
                config_device_option.value = row.protocol_val === 0? config_device_option_plc.value : config_device_option_can.value
                versionVisible.value = false
                showSave.value = false
                getConfigInfo(row.frame_number)
                break;
            case 'editItem': // 编辑配置行
                row.edit = !row.edit
                row.config_name_en = !row.config_name_en? '-' : row.config_name_en == '-'? '' : row.config_name_en
                row.config_name_de = !row.config_name_de? '-' : row.config_name_de == '-'? '' : row.config_name_de
                showSave.value = true
                break;
            case 'finishItem': // 配置行完成编辑
                row.edit = !row.edit
                row.config_name_en = !row.config_name_en? '-' : row.config_name_en == '-'? '' : row.config_name_en
                row.config_name_de = !row.config_name_de? '-' : row.config_name_de == '-'? '' : row.config_name_de
                row.finish = true
                configInfoTable.value.configs.table.rowClassName = (record, index) => {
                    if(record.finish && !record.addItem && !record.deleteItem){
                        return 'edit-row' 
                    }else if(record.addItem && !record.deleteItem){
                        return 'add-row' 
                    }else if(record.deleteItem){
                        return 'delete-row' 
                    }else{
                        return null
                    }
                }
                break;
            case 'log':
                resetVisible()
                logVisible.value = true
                modalVisible.value = true
                logActiveKey.value = '0'
                bleDateRange.value = []
                modalTitle.value = t('access.log')
                rowData.value = row
                logTable.value.configs.pagination.current = 1
                getLogList(row)
                break;
            case 'appBind': // 绑定记录
                resetVisible()
                bindRecordVisible.value= true
                modalVisible.value  = true
                modalTitle.value = t('access.bindRecord')
                rowData.value = row
                bindRecordTable.value.configs.pagination.current = 1
                getBindRecordList(row)  
                break;
            case 'torqueUpgradeRecord': // 扭矩升级记录
                resetVisible()
                torqueVisible.value = true
                modalVisible.value  = true
                modalTitle.value = t('access.torqueUpgradeRecord')
                rowData.value = row 
                getTorqueList(row.id)
                break;
            case 'softwareUpdate': // 软件更新记录
                softwareUpdateRecord()
                break;
            case 'motorReplacement': // 更换电机记录
                resetVisible()
                applyRecordVisible.value = true
                modalVisible.value  = true
                modalTitle.value = t('access.motorApplyRecord')
                rowData.value = row
                applyReplaceMotorRecordTable.value.configs.pagination.current = 1
                motorReplaceRecord(row.id)
                break;
            case 'deletePart': // 删除部件
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('access.deletePartConfirmMsg'),
                    okText: t('base.confirm'),
                    cancelText: t('base.cancel'),
                    onOk() {
                        deletePart(row)
                    },
                });
                break;
            case 'cancelTorque': // 取消扭矩升级
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('access.cancelTorqueUpgradeMsg'),
                    okText: t('base.confirm'),
                    cancelText: t('base.no'),
                    onOk() {
                        cancelTorque(row)
                    },
                    onCancel() {
                        row.upgrade_torque_status = 1
                    }
                });
                break;
            case 'cancleMotorReplace': // 取消更换电机
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('access.cancelMotorApplyMsg'),
                    okText: t('base.confirm'),
                    cancelText: t('base.no'),
                    onOk() {
                        cancleMotorReplace(row.id)
                    },
                    onCancel() {
                        row.motor_change_status = 1
                    }
                });
                break;
            case 'currentSetting': //  当前设置
                resetVisible()
                currentSettingVisible.value = true
                modalVisible.value = true
                modalTitle.value = t('access.currentSetting')
                rowData.value = row
                getSettingQuery(row)
                break;
            case 'poweronSession': // 上电信息
                resetVisible()
                poweronInfoVisible.value= true
                modalVisible.value  = true
                modalTitle.value = t('access.poweronSession')
                rowData.value = row
                poweronInfoTable.value.configs.pagination.current = 1
                getSeriesList(row)
                break;
            case 'poweronPosition': // 上电位置
                resetVisible()
                poweronPositionVisible.value= true
                modalVisible.value  = true
                modalTitle.value = t('access.poweronPosition')
                rowData.value = row
                poweronPositionTable.value.configs.pagination.current = 1
                getPoweronPositionList(row)
                break;
            case 'ebikeSetting': // 设置记录
                resetVisible()
                ebikeSettingVisible.value= true
                modalVisible.value  = true
                modalTitle.value = t('access.ebikeSetting')
                rowData.value = row
                settingRecordTable.value.configs.pagination.current = 1
                getSettingRecordList(row)
                break;
            case 'ebikeRepair': // 维修记录
                resetVisible()
                ebikeRepairVisible.value= true
                modalVisible.value  = true
                modalTitle.value = t('access.ebikeRepair')
                rowData.value = row
                repairRecordTable.value.configs.pagination.current = 1
                getRepairRecordList(row)
                break;
            case 'ebikeAuth': // 鉴权记录
                resetVisible()
                ebikeAuthVisible.value= true
                modalVisible.value  = true
                modalTitle.value = t('access.ebikeAuth')
                rowData.value = row
                authRecordTable.value.configs.pagination.current = 1
                getAuthRecordList(row)
                break;
            case 'getMotorKey': // 获取电机秘钥
                getMotorKey(row)
                break;
            case 'editCategory': // 编辑车辆类别
                rowData.value = row
                editCategoryValue.value = row.category_val !== undefined ? row.category_val : null
                editCategoryVisible.value = true
                break;
            case 'confirmEditCategory': // 确认保存车辆类别
                if(editCategoryValue.value === null){
                    message.error(t('base.select'))
                    return
                }
                saveCategory(rowData.value.id, editCategoryValue.value)
                editCategoryVisible.value = false
                break;
            case 'summary': // 汇总
                resetVisible()
                summaryVisible.value = true
                modalVisible.value = true
                modalTitle.value = t('access.summary')
                rowData.value = row
                summaryTable.value.configs.pagination.current = 1
                getSummeryData(row)
                break;
            case 'ebikeBarcode': // 生成邦车条码
                getBarCode(row)
                break;
            case 'motorQRCode': // 生成电机二维码
                getQRCode(row)
                break;
            case 'wheelCircumference': // 轮径
                editModalVisible.value = true
                editModalType.value = 'wheelCircumference'
                editModalTitle.value = t('access.wheelCircumference')
                rowData.value = row
                rowData.value.wheel_circumference = row.wheel_circumference === '-'? '' : row.wheel_circumference
                rowData.value.wheel_circumference_min = rowData.value.wheel_circumference == ''? 1300 : multiply(rowData.value.wheel_circumference, 0.85) < 1300? 1300 : multiply(rowData.value.wheel_circumference, 0.85).toFixed(0)
                rowData.value.wheel_circumference_max = rowData.value.wheel_circumference == ''? 3100 : multiply(rowData.value.wheel_circumference, 1.15) > 3100? 3100 : multiply(rowData.value.wheel_circumference, 1.15).toFixed(0)
                break;
            case 'maxSpeed': // 最大速度
                editModalVisible.value = true
                editModalType.value = 'maxSpeed' 
                editModalTitle.value = t('access.maxSpeed')
                row.max_speed = row.max_speed === '-'? '' : row.max_speed
                rowData.value = row
                break;
            // case 'cancelWheelCircumference': // 取消轮径变更
            //     Modal.confirm({
            //         title: t('base.tip'),
            //         content: t('access.cancelWheelCircumferenceConfirmTip'),
            //         okText: t('base.confirm'),
            //         cancelText: t('base.cancel'),
            //         onOk() {
            //             cancelWheelCircumferenceAndMaxSpeed(row, 'wheelCircumference')
            //         },
            //     });
            //     break;
            // case 'cancelMaxSpeed': // 取消最大速度变更
            //     Modal.confirm({
            //         title: t('base.tip'),
            //         content: t('access.cancelMaxSpeedConfirmTip'),
            //         okText: t('base.confirm'),
            //         cancelText: t('base.cancel'),
            //         onOk() {
            //             cancelWheelCircumferenceAndMaxSpeed(row, 'maxSpeed')
            //         },
            //     });
            //     break;
            case 'showSensitiveData': // 显示脱敏数据
                desensitizedData(row, key)
                break;
            case 'hideSensitiveData': // 隐藏脱敏数据
                if(key == 'email'){
                    row.email = row.email_desensitize.value
                    row.show_sensitive_email = true
                } 
                if(key == 'phone_key'){
                    row.phone_key = row.phone_key_desensitize.value
                    row.show_sensitive_phone_key = true
                } 
                if(key == 'motor_key'){
                    row.motor_key = row.motor_key_desensitize.value
                    row.show_sensitive_motor_key = true
                } 
                if(key == 'bind_email'){
                    row.bind_email = row.bind_email_desensitize.value
                    row.show_sensitive_bind_email = true
                } 
                break;
            case 'downLoad':  // 下载错误日志
                let token = sessionStorage.getItem('token')
                let url = `${import.meta.env.VITE_BASE_URL}/sys/upgrade/download?file_name=${row.file_name}&file_path=${row.file_path}&Authorization=Bearer ${token}`
                console.log(url,'url')
                let a = document.createElement('a')
                a.href = url
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                break;
            // case 'deletePartAll': // 清空部件
            //     Modal.confirm({
            //         title: t('base.tip'),
            //         content: t('access.deleteAllPartConfirm'),
            //         okText: t('base.confirm'),
            //         cancelText: t('base.cancel'),
            //         onOk() {
            //             deleteAllPart(row)
            //         },
            //     });
            //     break;
            case 'reStoreOffline': // 恢复下线
                Modal.confirm({
                    title: t('base.tip'),
                    content: t('access.restoreOfflineConfirm'),
                    okText: t('base.confirm'),
                    cancelText: t('base.cancel'),
                    onOk() {
                        restoreOffline(row)
                    },
                });
                break;
            case 'bindSKU': // 绑定SKU
                skuVisible.value = true
                rowData.value = row
                sku.value = row.sku == '-' ? '' : row.sku
                break;
            case 'editMVP': // 编辑MVP
                mvpVisible.value = true
                rowData.value = row
                mvp.value = row.mvp_val
                break;
            case 'exportRawData': // 打开导出原始数据弹窗
                rawDataVisible.value = true
                exportForm.exportType = ''
                exportForm.frame_number = row.frame_number
                exportForm.dateRange = ''
                exportForm.start_date = ''
                exportForm.end_date = ''
                rowData.value = row
                break;
        }
    }

    const handleSelectChange = (type)=>{
        if(type == 'frame_number'){
            searchForm.assembly_code = null
        }else if(type == 'assembly_code'){
            searchForm.frame_number = null
        }else if(type == 'tenant'){
            searchForm.frame_number = null
            searchForm.assembly_code = null
        }
        table.value.configs.pagination.current = 1

        getFrameAndMotor()
        getVehicleList()
    }


    const handleInputChange = useDebounceFn((type)=>{
        if(type == 'assembly_code'){
            searchForm.frame_number = null
        }else if(type == 'tenant'){
            searchForm.frame_number = null
            searchForm.assembly_code = null
        }
        table.value.configs.pagination.current = 1

        getFrameAndMotor()
        getVehicleList()
    }, 500)

    const handleInputChangeEmail = useDebounceFn(()=>{
        table.value.configs.pagination.current = 1
        getVehicleList()
    }, 500)

    const handleSearch = ()=>{
        console.log('搜索')
        getVehicleList()
    }

    // 获取车辆部件信息
    const expandRow = (expanded,row)=>{
        if(expanded){
            rowData.value = row
            getPartsVersion(row.id)
        } 
    }

    // 获取车架号、电机总成
    const getFrameAndMotor = async (val, type)=>{
        let param = {   
            tenant_id: userInfo.value.tenant_id == 1? searchForm.tenant_id : userInfo.value.tenant_id,
        }
        if(type && type == 'frame_number') param.frame_number = val
        if(type && type == 'assembly_code') param.triple_id = val

        fetching.value = true
        let res = await CyclingApi.getInstance().getFrameAndMotor(param, 1, 50)
        if(res.code === 0){
            fetching.value = false
            frameNumberOptions.value = []
            motorCodeOptions.value = []

            res.data.records.length > 0 && res.data.records.forEach(item=>{
                if(item.frame_number){
                    frameNumberOptions.value.push({
                        label: item.frame_number,
                        value: item.frame_number,
                        user_id: item.user_id,
                        vehicle_id: item.id,
                    })
                }
                
                if(item.triple_id){
                    motorCodeOptions.value.push({
                        label: item.triple_id,
                        value: item.triple_id,
                        user_id: item.user_id,
                        vehicle_id: item.id,
                    })
                }
            })
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取整车列表
    const getVehicleList = async ()=>{
        let param = {
            frame_number: searchForm.frame_number || '',
            triple_id: searchForm.assembly_code || '',
            tenant_id: userInfo.value.tenant_id == 1? searchForm.tenant_id : userInfo.value.tenant_id,
            email: searchForm.email || '',
        }
        let page_num = table.value.configs.pagination.current
        let page_size =  table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await AdvancedFunApi.getInstance().getVehicleList(param,page_num,page_size)
        if(res.code === 0){
            let fieldArr = ['frame_number', 'triple_id', 'color', 'email', 'phone_key','motor_key','wheel_circumference','max_speed']
            let userCategoryObj = {
                0: t('access.appSelf'),
                1: t('access.commonUser'),
                2: t('access.google'),
                3: t('access.apple'),
                4: t('access.facebook'),
            }
            res.data.records.length > 0 && res.data.records.forEach(item => {
                item.max_torque = item.max_torque == undefined? '-' : `${Number(item.max_torque) / 100} Nm`
                item.upgrade_torque_status = item.change_torque == undefined? '' : 1
                item.motor_change_status = item.change_motor == 1? 1 : ''
                item.protocol_val = item.protocol
                item.protocol = item.protocol == undefined? '-' : item.protocol === 0? t('access.plc') : t('access.can')
                const addItem = [{
                    value:'40 Nm',
                    label:'40 Nm',
                    disabled: false,
                    key:'4000',
                }]
                item.torqueOptions = item.protocol_val == 1? (String(item.triple_id).indexOf('J') === 1 ? addItem.concat(can_max_torqueOptions.value) : can_max_torqueOptions.value) : plc_max_torqueOptions.value
                item.show_sensitive_email = true
                item.show_sensitive_phone_key = true
                item.show_sensitive_motor_key = true
                item.max_speed = item.maximum_speed_limit == undefined? '-' : `${item.maximum_speed_limit}`
                item.wheel_circumference = item.wheel_circumference !== undefined? item.wheel_circumference : item.wheel_radius == undefined? '-' : `${Math.round(multiply(item.wheel_radius, 6.28))}`
                item.category_val = item.category
                item.category = item.category == undefined? '-' : item.category == 0 ? t('access.marketEbike') : t('access.testEbike')
                item.user_category = item.user_category == undefined? '-' : userCategoryObj[item.user_category]
                item.use_markup = item.use_markup == undefined? '-' : item.use_markup == 0? t('access.main_vehicle') : t('access.free_vericle'),
                item.vehicle_status_val = item.vehicle_status
                item.vehicle_status = item.vehicle_status == undefined? '-' : item.vehicle_status == 0? t('access.activated') : item.vehicle_status == 1? t('access.unbound') : t('access.maintenance')
                // item.user_identifier = !item.user_identifier? '-' : item.user_identifier
                fieldArr.map(m=>{
                    item[m] = getFieldVal(item[m])
                }),
                item.hasMotorReplaceAuth = dropMenuItemKeys.value.includes('motorReplace')
                item.hasTorqueUpgradeAuth = dropMenuItemKeys.value.includes('torqueUpgrade')
                item.sku = item.sku == undefined? '-' : item.sku
                item.mvp_val = item.mvp
                item.mvp = item.mvp == undefined? '-' : item.mvp == 0? t('base.yes') : t('base.no')
            })
            
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
            
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 脱敏数据
    const desensitizedData = async (row, key)=>{
        let param = {
            request_param: key == 'email'? JSON.stringify(row.email_desensitize) 
                            : key == 'phone_key'? JSON.stringify(row.phone_key_desensitize) 
                            : key == 'motor_key'? JSON.stringify(row.motor_key_desensitize) 
                            : JSON.stringify(row.bind_email_desensitize),
        }
        const id = key == 'email'? row.id : key == 'phone_key'? row.phone_key_id : key == 'motor_key'? row.motor_key_id : row.id
        let res = await AdvancedFunApi.getInstance().desensitizedData(param, id)
        if(res.code === 0){
            message.success(t('base.success'))
            if(key == 'email'){
                row.email = res.data
                row.show_sensitive_email = false
            } 
            if(key == 'phone_key'){
                row.phone_key = res.data
                row.show_sensitive_phone_key = false
            } 
            if(key == 'motor_key'){
                row.motor_key = res.data
                row.show_sensitive_motor_key = false
            } 
            if(key == 'bind_email'){
                row.bind_email = res.data
                row.show_sensitive_bind_email = false
            } 
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 修改扭矩
    const torqueUpgrade = async ()=>{
        console.log(rowData.value,'rowData')
        let param = {
            vehicle_id: rowData.value.id,
            target_torque: torque.value.split(' Nm')[0] * 100,//row.target_torque
        }
        let res = await AdvancedFunApi.getInstance().editTorque(param)
        if(res.code === 0){
            message.success(t('access.torqueEditSuccessMsg'))
            getVehicleList()
            torqueUpdateVisible.value = false
            rowData.value.upgrade_torque_status = 1
            console.log(rowData.value, 'upgrade_torque_status')
        }else{
            getVehicleList()
            message.error(res.msg || res.message)
        }
    }

    // 取消扭矩升级
    const cancelTorque = async (row)=>{
        console.log(row,'rowwwww', rowData.value)
        let res = await AdvancedFunApi.getInstance().cancelTorqueUpgrade(row.id)
        if(res.code === 0){
            message.success(t('base.cancelSuccessMsg'))
            getVehicleList()
            rowData.value.upgrade_torque_status = 1
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 解绑用户
    const unbindUser = async (row)=>{
        let res = await AdvancedFunApi.getInstance().unbindBikeUser(row.id)
        if(res.code === 0){
            message.success(t('access.unboundSuccessful'))
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 更换电机前，获取配置信息
    const getConfigInfo = async (frame_number, type)=>{
        if(type == 'replaceMotorConfirm'){
            confirmConfigInfoTable.value.configs.loading = true
        }else{
            configInfoTable.value.configs.loading = true
        } 
        let res = await AdvancedFunApi.getInstance().getConfigInfo(frame_number)
        if(res.code === 0){
            if(type == 'replaceMotorConfirm'){
                confirmConfigInfoTable.value.data = []
                res.data.config.length > 0 && res.data.config.forEach((item,index)=>{
                    confirmConfigInfoTable.value.data.push({
                        ...item,
                        index:index,
                        config_name_en: !item.config_name_en? '-' : item.config_name_en,
                        config_name_de: !item.config_name_de? '-' : item.config_name_de,
                        config_encrypt:item.config_encrypt? t('base.YES') : t('base.NO'),
                        edit:false,
                    }) 
                })
                confirmConfigInfoTable.value.configs.loading = false
            }else{
                configInfoTable.value.data = []
                res.data.config.length > 0 && res.data.config.forEach((item,index)=>{
                    configInfoTable.value.data.push({
                        ...item,
                        index:index,
                        serial: index + 1,
                        config_name_en: !item.config_name_en? '-' : item.config_name_en,
                        config_name_de: !item.config_name_de? '-' : item.config_name_de,
                        config_encrypt:item.config_encrypt? t('base.YES') : t('base.NO'),
                        disabled: item.config_item == '1684' || item.config_item == '0004',
                        edit:false,
                    }) 
                })
                configInfoTable.value.configs.loading = false
            }
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 更换电机
    const applyReplaceMotor = async (id)=>{
        let param = {
            vehicle_id:id,
            category: replace_motor_category.value,  // 1:换电机  2：更新配置
        }
        let res = await AdvancedFunApi.getInstance().applyReplaceMotor(param)
        if(res.code === 0){
            message.success(t('base.success'))
            confirmConfigInfoVisible.value = false
            getVehicleList()
        }else{
            Modal.error({
                title: t('base.error'),
                content: res.msg,
                okText: t('base.ok'),
            })
        }
    }

    // 取消更换电机申请
    const cancleMotorReplace = async (id)=>{
        let res = await AdvancedFunApi.getInstance().cancleApply(id)
        if(res.code === 0){
            message.success(t('base.cancelSuccessMsg'))
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

     // 添加配置行
    const addConfig = ()=>{
        showSave.value = true
        configInfoTable.value.data.push({
            index: configInfoTable.value.data.length,
            serial: configInfoTable.value.data.length + 1,
            config_name: '',
            config_name_en: '',
            config_name_de: '',
            config_item: '',
            config_value: '',
            config_encrypt: '',
            config_unit: '',
            config_min: '',
            config_max: '',
            config_size: '',
            config_device: '',
            config_coefficient: '',
            edit:true,
            addItem:true
        })
        configInfoTable.value.configs.table.rowClassName = (record, index) => {
            if(record.addItem){
                return 'add-row' 
            }else if(record.deleteItem){
                return 'delete-row' 
            }else if(record.finish && !record.addItem){
                return 'edit-row' 
            }else{
                return null
            }
        }
    }

    // 删除配置行
    const deleteConfigItem = (row)=>{
        // console.log(row,'del')
        // console.log(configInfoTable.value.data,'ddd')
        showSave.value = true
        row.deleteItem = true
        row.edit = false
        configInfoTable.value.configs.table.rowClassName = (record, index) => {
            if(record.deleteItem){
                return 'delete-row' 
            }else if(record.addItem){
                return 'add-row' 
            }else if(record.finish && !record.addItem){
                return 'edit-row' 
            }else{
                return null
            }
        }
    }

    // 撤销删除
    const revokeDeleteConfigItem = (row)=>{
        row.deleteItem = false
    }

    // 更新配置信息
    const saveConfig = async ()=>{
        let param = []

        if(configInfoTable.value.data.length == 0){
            message.error(t('access.saveConfigTip'))
            return 
        }

        for(let i=0; i<configInfoTable.value.data.length; i++){
            let item = configInfoTable.value.data[i]
            if(!item.config_name && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_name') + ' ' + t('base.noEmpty'))
                return
            }else if(!item.config_device  && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_device') + ' ' + t('base.noEmpty'))
                return
            }else if(!item.config_item  && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_item') + ' ' + t('base.noEmpty'))
                return
            }else if((item.config_max === '' || item.config_max === null) && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_max') + ' ' + t('base.noEmpty'))
                return
            }else if((item.config_min === '' || item.config_min === null) && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_min') + ' ' + t('base.noEmpty'))
                return
            }else if((item.config_value === '' || item.config_value === null) && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_value') + ' ' + t('base.noEmpty'))
                return
            }else if((item.config_size === '' || item.config_size === null) && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_size') + ' ' + t('base.noEmpty'))
                return
            }else if(!item.config_unit && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_unit') + ' ' + t('base.noEmpty'))
                return
            }else if((item.config_coefficient === '' || item.config_coefficient === null) && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_coefficient') + ' ' + t('base.noEmpty'))
                return
            }else if(item.config_encrypt === '' && !item.deleteItem){
                message.error(`#${item.serial}: ` + t('access.config_encrypt') + ' ' + t('base.noEmpty'))
                return
            }
        }

        configInfoTable.value.data.forEach(i=>{
            if(!i.deleteItem){
                param.push({
                    config_name: i.config_name,
                    config_name_en: i.config_name_en,
                    config_name_de: i.config_name_de,
                    config_device: i.config_device,
                    config_item: i.config_item,
                    config_value: i.config_value,
                    config_min: i.config_min,
                    config_max: i.config_max,
                    config_size: i.config_size,
                    config_unit: i.config_unit,
                    config_encrypt: i.config_encrypt == t('base.YES')? true : i.config_encrypt === true? true : false,
                    config_coefficient: i.config_coefficient,
                }) 
            }
        })
        console.log(param,'param')

        let res = await AdvancedFunApi.getInstance().updateConfigInfo(param, rowData.value.frame_number)
        if(res.code === 0){
            message.success(t('base.saveSuccessMsg'))
            showSave.value = false
            getConfigInfo(rowData.value.frame_number)
        }else{
            message.error(res.msg || res.message)
        }
    }

    const changeInputNumber = useDebounceFn((val,row)=>{
        // console.log(val, row, 'iiiiiii')
        if(row.config_max !== '' && row.config_max !== null && val > row.config_max){
            message.error(t('access.valueMaxTip'))
        }
        if(row.config_min !== '' && row.config_min !== null &&val < row.config_min){
            message.error(t('access.valueMinTip'))
        }
    },1000) 

    const getVersion = ()=>{
        versionVisible.value = true
        versionActiveKey.value = '0'
        getVersionList()
    }

    // 获取配置信息历史版本
    const getVersionList = async()=>{
        let param = {
            vehicle_id: rowData.value.id,
        }
        let page_num = versionPageNum.value
        let page_size = versionPageSize.value
        let res = await AdvancedFunApi.getInstance().configVersionList(param, page_num, page_size)
        if(res.code === 0){
            versionList.value = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                versionList.value.push({
                    ...item,
                    key:index,
                    create_timestamp_val: item.create_timestamp,
                    create_timestamp: timestampToDate(item.create_timestamp * 1000),
                })
            })

            versionListTotal.value = res.data.total
            maxPageNum.value = Math.ceil(res.data.total / 10)
            changeCollapse(0)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 版本列表上一页/下一页
    const prevPage = ()=>{
        if(versionPageNum.value == 1) return
        else {
            versionPageNum.value--
            getVersionList()
        }
    }
    const nextPage = ()=>{
        if(versionPageNum.value == maxPageNum.value) return
        else {
            versionPageNum.value++
            getVersionList()
        }
    }

    // 显示某一版本配置信息表格
    const changeCollapse = (key)=>{
        // console.log(key,'key')
        let data = [], configChangeItemData = []
        if(key !== undefined && versionList.value[key]) data = versionList.value[key].previous_config_list
        if(!!versionList.value[key].change_config) configChangeItemData = JSON.parse(versionList.value[key].change_config)

        versionTable.value.data = []
        data.length > 0 && data.forEach(item=>{
            versionTable.value.data.push({
                ...item,
                config_name_en: item.config_name_en == ''? '-' : item.config_name_en,
                config_name_de: item.config_name_de == ''? '-' : item.config_name_de,
                config_encrypt:item.config_encrypt? t('base.YES') : t('base.NO'),
            })
        })

        configChangeItemTable.value.data = []
        configChangeItemData.length > 0 && configChangeItemData.forEach(item=>{
            configChangeItemTable.value.data.push({
                ...item,
                configName: !item.configName? '-' : item.configName,
                configItem: !item.configItem? '-' : item.configItem,
                configOldValue: !item.configOldValue? '-' : item.configOldValue,
                configNewValue: !item.configNewValue? '-' : item.configNewValue,
                category_val: item.category,
                category: item.category === 0? t('base.modify') : item.category === 1? t('base.add') : t('base.delete'), 
            })
        })
    }

    // 版本回退
    const rollBack = (row)=>{
        Modal.confirm({
            title: t('base.tip'),
            content: t('access.confirmRollBackTip'),
            onOk: async()=> {
                let res = await AdvancedFunApi.getInstance().versionRollBack({ id: row.id, vehicle_id: row.vehicle_id, create_timestamp: new Date().getTime().toString().slice(0,10) })
                if(res.code === 0){
                    message.success(t('access.rollBackSuccess'))
                    versionVisible.value = false
                    getConfigInfo(frameNumber.value)
                }else{
                    message.error(res.msg || res.message)
                }
            },
        })
    }

    // 升级日志切换tab
    const changeTab = (val)=>{
        // logTable.value.configs.pagination.current = 1
        // getLogList(rowData.value)
    }

    // BluetoothLog 日期筛选
    const bleDateRange = ref([])
    const onBleDateChange = ()=>{
        if(logActiveKey.value == '6'){
            logTable.value.configs.pagination.current = 1
            getLogList(rowData.value)
        }
    }

    // 获取日志列表
    const getLogList = async (row)=>{
        let page_num = logTable.value.configs.pagination.current
        let page_size = logTable.value.configs.pagination.pageSize
        logTable.value.configs.loading = true

        // BluetoothLog（activeKey == '6'）传区间时间（start_timestamp/end_timestamp，单位：秒）
        let res
        if (logActiveKey.value == '6') {
            const param = {
                vehicle_id: String(row.id || ''),
                // app_version: row.app_version || '',
            }
            const hasRange = Array.isArray(bleDateRange.value) && bleDateRange.value.length === 2
            if (hasRange) {
                const startDate = new Date(bleDateRange.value[0])
                const endDate = new Date(bleDateRange.value[1])
                const startOfDayMs = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0).getTime()
                const endOfDayMs = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999).getTime()

                param.start_timestamp = String(Math.floor(startOfDayMs / 1000))
                param.end_timestamp = String(Math.floor(endOfDayMs / 1000))
            }
            logTable.value.configs.loading = true
            res = await AdvancedFunApi.getInstance().getBluetoothLog(param, page_num, page_size)
        } else {
            const param = {
                vehicle_id:row.id,
                sync_category:logActiveKey.value,
            }
            res = await AdvancedFunApi.getInstance().getLogInfo(param, page_num, page_size)
        }
        if(res.code === 0){
            logTable.value.data = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                // logTable.value.data.push({
                //     ...item,
                //     order_number:index + 1,
                //     assembly_no: !item.assembly_no? '-' : item.assembly_no,
                //     part_no:item.part_no == undefined? '-' : item.part_no,
                //     hardware_version:item.hardware_version == undefined? '-' : item.hardware_version,
                //     software_version:item.software_version == undefined? '-' : item.software_version,
                //     init_software_version:item.init_software_version == undefined? '-' : item.init_software_version,
                //     upgrade_time:item.upgrade_time == undefined? '-' : item.upgrade_time,
                //     upgrade_excep:item.upgrade_excep == undefined? '-' : item.upgrade_excep,
                //     start_timestamp:item.start_timestamp == undefined? '-' : item.start_timestamp,
                //     end_timestamp:item.end_timestamp == undefined? '-' : item.end_timestamp,
                //     project_no: item.project_no == undefined? '-' : item.project_no,
                //     ride_no: item.ride_no == undefined? '-' : item.ride_no,
                // })

                if(logActiveKey.value == '6'){
                    logTable.value.data.push({
                        ...item,
                        order_number: index + 1,
                        app_version: item.app_version == undefined? '-' : item.app_version,
                        device_system: item.device_system == undefined? '-' : item.device_system,
                        upload_timestamp: item.upload_timestamp == undefined? '-' : timestampToDate(item.upload_timestamp),
                        file_no: item.file_no == undefined? '-' : item.file_no,
                    })
                    logTable.value.configs.loading = false
                } else {
                    logTable.value.data.push({
                        ...item,
                        order_number: index + 1,
                        assembly_no: !item.assembly_no? '-' : item.assembly_no,
                        part_no:item.part_no == undefined? '-' : item.part_no,
                        hardware_version:item.hardware_version == undefined? '-' : item.hardware_version,
                        software_version:item.software_version == undefined? '-' : item.software_version,
                        init_software_version:item.init_software_version == undefined? '-' : item.init_software_version,
                        // upgrade_time:item.upgrade_time == undefined? '-' : item.upgrade_time,
                        upgrade_time:item.upgrade_timestamp == undefined? '-' : timestampToDate(item.upgrade_timestamp * 1000), 
                        upgrade_excep:item.upgrade_excep == undefined? '-' : item.upgrade_excep,
                        start_timestamp:item.start_timestamp == undefined? '-' : item.start_timestamp,
                        end_timestamp:item.end_timestamp == undefined? '-' : item.end_timestamp,
                        project_no: item.project_no == undefined? '-' : item.project_no,
                        ride_no: item.ride_no == undefined? '-' : item.ride_no,
                    })
                }
            })
            logTable.value.configs.pagination.total = res.data.total
            logTable.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }

    // 获取错误日志列表
    const getErrorLog = async (row)=>{
        logTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getErrorLog(row.id)
        if(res.code === 0){
            logTable.value.data = []
            res.data.length > 0 && res.data.forEach((item,index)=>{
                logTable.value.data.push({
                    ...item,
                    order_number:index + 1,
                    ride_no: item.ride_no == undefined? '-' : item.ride_no,
                })
            })
            logTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

     // 获取故障日志列表
     const getFaultLog = async (row)=>{
        let param = {
            page_num: logTable.value.configs.pagination.current,
            page_size: logTable.value.configs.pagination.pageSize,
        }

        logTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getFaultLog(param,row.id)
        if(res.code === 0){
            logTable.value.data = []
                res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                    logTable.value.data.push({
                    ...item,
                    order_number:index + 1,
                    distance: !item.distance? '-' : item.distance,
                    app_version: item.app_version == undefined? '-' : item.app_version,
                    fault_code: item.fault_code == undefined? '-' : item.fault_code,
                })
            })
            logTable.value.configs.loading = false
            logTable.value.configs.pagination.total = res.data.total
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 绑定app记录
    const getBindRecordList = async (row)=>{
        let param = {
            vehicle_id:row.id,
        }
        let page_num = bindRecordTable.value.configs.pagination.current
        let page_size =  bindRecordTable.value.configs.pagination.pageSize
        bindRecordTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getBindRecordList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(item=>{
                item.bind_email = item.email == undefined || item.email == ''? '-' : item.email
                item.bind_category = item.bind_category == undefined? '-' : item.bind_category == 0? t('access.binding') : t('access.unbinding')
                item.bind_timestamp = item.bind_timestamp == undefined? '-' : timestampToDate(item.bind_timestamp * 1000) 
                item.bind_email_desensitize = item.email_desensitize
                item.show_sensitive_bind_email = true
                // item.bind_mode_category = item.bind_mode_category == undefined? '-' : item.bind_mode_category == 1? t('access.assembly') : t('access.frame')
            })
            bindRecordTable.value.data = res.data.records
            bindRecordTable.value.configs.pagination.total = res.data.total
            bindRecordTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 扭矩升级记录
    const getTorqueList = async (id)=>{
        let param = {
            vehicle_id:id,
        }
        editTorqueTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getTorqueList(param)
        if(res.code === 0){
            editTorqueTable.value.data = []
            res.data.forEach(item=>{
                editTorqueTable.value.data.push({
                    ...item,
                    init_torque:item.init_torque === undefined? '-' : item.init_torque / 100 + ' Nm',
                    target_torque:item.target_torque / 100 + ' Nm',
                    status_val: item.status,
                    status:item.status == 0? t('access.finish') : item.status == 1? t('access.waitUpgrade') : t('access.cancel'),
                    change_timestamp: !item.change_timestamp? '-' : timestampToDate(item.change_timestamp * 1000),
                    create_timestamp: !item.create_timestamp? '-' : timestampToDate(item.create_timestamp * 1000),  
                    cancel_timestamp: !item.cancel_timestamp? '-' : timestampToDate(item.cancel_timestamp * 1000),
                    cancel_time: !item.cancel_time? '-' : item.cancel_time,
                })
            })
            
            editTorqueTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 更换电机记录
    const motorReplaceRecord = async (id)=>{
        let param = {
            vehicle_id:id
        }
        let page_num = applyReplaceMotorRecordTable.value.configs.pagination.current
        let page_size =  applyReplaceMotorRecordTable.value.configs.pagination.pageSize
        applyReplaceMotorRecordTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().applyRecord(param,page_num,page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(item=>{
                item.cycling_mileage = item.cycling_mileage == undefined? '-' :item.cycling_mileage
                item.target_triple_id = item.target_triple_id == undefined? '-' :item.target_triple_id
                item.status_val = item.status
                item.status = item.status == 0? t('access.finish') : item.status == 1? t('access.toBeReplace') : t('access.cancel')
                item.category = !item.category? t('access.applyReplaceMotor') : item.category == 1? t('access.applyReplaceMotor') : t('access.replaceConfig')
                item.platform = item.platform == undefined? '-' : item.platform == 0? t('access.app') : t('access.serviceTool')
                item.change_timestamp = !item.change_timestamp? '-' : timestampToDate(item.change_timestamp * 1000)
                item.create_timestamp = !item.create_timestamp? '-' : timestampToDate(item.create_timestamp * 1000)
            })
            applyReplaceMotorRecordTable.value.data = res.data.records
            applyReplaceMotorRecordTable.value.configs.pagination.total = res.data.total
            applyReplaceMotorRecordTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取当前设置列表
    const getSettingQuery = async (row)=>{
        let param = {
            vehicle_id:row.id,
        }
        currentSettingTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getCurrentSetting(param)
        if(res.code === 0){
            res.data.length > 0 && res.data.forEach(item=>{
                item.auto_light = item.auto_light == undefined? '-' : item.auto_light == 0? t('access.turnOff') : t('access.turnOn')
                item.beeper = item.beeper == undefined? '-' : item.beeper == 0? t('access.turnOff') : t('access.turnOn')
                item.low_battery = item.low_battery == undefined? '-' : item.low_battery == 0? t('access.turnOff') : t('access.turnOn')
                item.language = item.language == undefined? '-' : item.language
                item.phone_key = item.phone_key == undefined? '-' : item.phone_key
                item.motor_key = item.motor_key == undefined? '-' : item.motor_key
                item.units = item.units == undefined? '-' : item.units
                item.assist_level = item.assist_level == undefined? '-' : item.assist_level
                item.maximum_torque = item.maximum_torque == undefined? '-' : item.maximum_torque + ' Nm'
                item.mode = item.mode == undefined? '-' : item.mode
                item.recognition_sensitivity = item.recognition_sensitivity == undefined? '-' : item.recognition_sensitivity
                item.start_response = item.start_response == undefined? '-' : item.start_response
                item.trolley_speed = item.trolley_speed == undefined? '-' : multiply(item.trolley_speed, 0.1) + ' km/h'
                item.wheel_diameter = item.wheel_diameter == undefined? '-' : multiply(item.wheel_diameter, 0.1) + '%'
            })
            currentSettingTable.value.data = res.data
            currentSettingTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取上电信息列表
    const getSeriesList = async (row)=>{
        let param = {
            frame_number:row.frame_number,
            sys_org: row.tenant_id,
        }
        let page_num = poweronInfoTable.value.configs.pagination.current
        let page_size =  poweronInfoTable.value.configs.pagination.pageSize
        poweronInfoTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getSeriesList(param, page_num, page_size)
        if(res.code === 0){
            poweronInfoTable.value.data = []
            res.data.records.forEach(item=>{
                item.mode_total = (item.eco_mode || 0) + (item.off_mode || 0) + (item.tour_mode || 0) + (item.turbo_mode || 0) + (item.boost_mode || 0)+ (item.auto_mode || 0)
                poweronInfoTable.value.data.push({
                    ...item,
                    distance: item.distance == undefined? '-' : item.distance + ' m',
                    cost_time: item.cost_time == undefined? '-' : item.cost_time + ' s',
                    average_speed: item.average_speed == undefined? '-' : item.average_speed + ' km/h',
                    highest_speed: item.highest_speed == undefined? '-' : item.highest_speed + ' km/h',
                    power_consumption: item.power_consumption == undefined? '-' : item.power_consumption + ' %',
                    ride_date: timestampToDate(item.ride_timestamp * 1000),
                    eco_mode: item.mode_total == 0? 0 : (item.eco_mode / item.mode_total * 100).toFixed(2) + ' %',
                    off_mode: item.mode_total == 0? 0 : (item.off_mode / item.mode_total * 100).toFixed(2) + ' %',
                    tour_mode: item.mode_total == 0? 0 : (item.tour_mode / item.mode_total * 100).toFixed(2) + ' %',
                    turbo_mode: item.mode_total == 0? 0 : (item.turbo_mode / item.mode_total * 100).toFixed(2) + ' %',
                    boost_mode: item.mode_total == 0? 0 : item.boost_mode == undefined? '-' : (item.boost_mode / item.mode_total * 100).toFixed(2) + ' %',
                    auto_mode: item.mode_total == 0? 0 : item.auto_mode == undefined? '-' : (item.auto_mode / item.mode_total * 100).toFixed(2) + ' %',
                })
            })
            poweronInfoTable.value.configs.pagination.total = res.data.total
            poweronInfoTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取上电位置列表
    const getPoweronPositionList = async (row)=>{
        let param = { vehicle_id: row.id }
        let page_num = poweronPositionTable.value.configs.pagination.current
        let page_size =  poweronPositionTable.value.configs.pagination.pageSize
        poweronPositionTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getPoweronPositionList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(item=>{
                item.user_id = item.user_id == undefined? '-' : item.user_id
                item.app_version = item.app_version == undefined? '-' : item.app_version
                item.ride_no = item.ride_no == undefined? '-' : item.ride_no
                item.latitude = item.latitude == undefined? '-' : item.latitude
                item.longitude = item.longitude == undefined? '-' : item.longitude
                item.elevation = item.elevation == undefined? '-' : item.elevation + ' m'
                item.report_category = item.report_category == undefined? '-' : item.report_category == 0? t('access.poweronOpen') : t('access.poweronOff')
                // item.report_time = item.report_time == undefined? '-' : item.report_time
                item.report_time = item.report_timestamp == undefined? '-' : timestampToDate(item.report_timestamp * 1000)
            })
            poweronPositionTable.value.data = res.data.records
            poweronPositionTable.value.configs.pagination.total = res.data.total
            poweronPositionTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取设置记录列表
    const getSettingRecordList = async (row)=>{
        let param = { vehicle_id:row.id }
        let page_num = settingRecordTable.value.configs.pagination.current
        let page_size =  settingRecordTable.value.configs.pagination.pageSize
        settingRecordTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getSettingRecordList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(item=>{
                item.auto_light = item.auto_light == undefined? '-' : item.auto_light == 0? t('access.turnOff') : t('access.turnOn')
                item.beeper = item.beeper == undefined? '-' : item.beeper == 0? t('access.turnOff') : t('access.turnOn')
                item.low_battery = item.low_battery == undefined? '-' : item.low_battery == 0? t('access.turnOff') : t('access.turnOn')
                item.language = item.language == undefined? '-' : item.language
                item.phone_key = item.phone_key == undefined? '-' : item.phone_key
                item.motor_key = item.motor_key == undefined? '-' : item.motor_key
                item.units = item.units == undefined? '-' : item.units
                item.assist_level = item.assist_level == undefined? '-' : item.assist_level
                item.maximum_torque = item.maximum_torque == undefined? '-' : item.maximum_torque
                item.mode = item.mode == undefined? '-' : item.mode
                item.recognition_sensitivity = item.recognition_sensitivity == undefined? '-' : item.recognition_sensitivity
                item.start_response = item.start_response == undefined? '-' : item.start_response
                item.ride_no = item.ride_no == undefined? '-' : item.ride_no
                item.trolley_speed = item.trolley_speed == undefined? '-' : multiply(item.trolley_speed, 0.1) + ' km/h'
                item.wheel_diameter = item.wheel_diameter == undefined? '-' : multiply(item.wheel_diameter, 0.1) + '%'
                item.show_sensitive_phone_key = true
                item.show_sensitive_motor_key = true
            })
            settingRecordTable.value.data = res.data.records
            settingRecordTable.value.configs.pagination.total = res.data.total
            settingRecordTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取维修记录列表
    const getRepairRecordList = async (row)=>{
        let param = { vehicle_id:row.id }
        let page_num = repairRecordTable.value.configs.pagination.current
        let page_size =  repairRecordTable.value.configs.pagination.pageSize
        repairRecordTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getRepairRecordList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(item=>{
                item.status = item.status == undefined? '-' : item.status == 0? t('access.open') : item.status == 1? t('access.end') : t('access.repairing')
                item.category = item.category == undefined? '-' : item.category == 0? t('access.repair') : t('access.returnGoods')
                item.mes_sync = item.mes_sync == undefined? '-' : item.mes_sync == 0? t('access.synchronized') : t('access.abnormal')
            })
            repairRecordTable.value.data = res.data.records
            repairRecordTable.value.configs.pagination.total = res.data.total
            repairRecordTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取鉴权记录列表
    const getAuthRecordList = async (row)=>{
        let param = { vehicle_id:row.id }
        let page_num = authRecordTable.value.configs.pagination.current
        let page_size =  authRecordTable.value.configs.pagination.pageSize
        authRecordTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getAuthRecordList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(item=>{
                item.auth_result = item.auth_result == 0 ? t('access.success'): t('access.failed')
                item.ride_no = item.ride_no == undefined? '-' : item.ride_no
                item.auth_desc = item.auth_desc == undefined || item.auth_desc === '' ? '-' : item.auth_desc
                item.start_date = item.start_timestamp == undefined? '-' : timestampToDate(item.start_timestamp * 1000)
                item.end_date = item.end_timestamp == undefined? '-' : timestampToDate(item.end_timestamp * 1000)
            })
            authRecordTable.value.data = res.data.records
            authRecordTable.value.configs.pagination.total = res.data.total
            authRecordTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取电机秘钥
    const getMotorKey = async (row)=>{
        let res = await AdvancedFunApi.getInstance().getMotorKey(row.id)
        if(res.code === 0){
            Modal.info({ title: t('access.getMotorKey'), content: res.data.en_key, centered: true })
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 保存车辆类别
    const saveCategory = async (id, category)=>{
        let res = await AdvancedFunApi.getInstance().saveCategory(id, category)
        if(res.code === 0){
            message.success(t('base.editSuccessMsg'))
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取 Summary 数据
    const getSummeryData = async (row)=>{
        let param = {
            vehicle_id: row.id,
        }
        let page_num = summaryTable.value.configs.pagination.current
        let page_size = summaryTable.value.configs.pagination.pageSize
        summaryTable.value.configs.loading = true
        let res = await AdvancedFunApi.getInstance().getSummeryData(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.length > 0 && res.data.records.forEach(i=>{
                i.ride_no = !i.ride_no? '-' : i.ride_no
                i.cycling_mileage = !i.cycling_mileage? '-' : `${(Number(i.cycling_mileage) / 1000)} km`
                i.cadence = !i.cadence? '-' : i.cadence
                i.triple_id = !i.triple_id? '-' : i.triple_id
                i.ecu_software_version = !i.ecu_software_version? '-' : i.ecu_software_version
                i.bms_software_version = !i.bms_software_version? '-' : i.bms_software_version
                i.ccu_software_version = !i.ccu_software_version? '-' : i.ccu_software_version
                i.meter_software_version = !i.meter_software_version? '-' : i.meter_software_version
                i.ride_timestamp = !i.ride_timestamp? '-' : timestampToDate(i.ride_timestamp * 1000)
            })
            summaryTable.value.data = res.data.records
            summaryTable.value.configs.pagination.total = res.data.total
            summaryTable.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取邦车条码
    const getBarCode = async(row)=>{
        let param = { id: row.id }
        let res = await AdvancedFunApi.getInstance().getBarCode(param)
        if(res.code === 0){
            barcodeVisible.value = true
            barcodeUrl.value = res.data
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取电机二维码
    const getQRCode = async(row)=>{
        let param = { id: row.id }
        let res = await AdvancedFunApi.getInstance().getQRCode(param)
        if(res.code === 0){
            if(res.data.triple_id){
                qrcodeVisible.value = true
                qrcodeUrl.value = res.data.triple_id
            }else{
                Modal.info({
                    title: t('base.tip'),
                    content: t('base.noData'),
                })
            }
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 清空部件
    const deleteAllPart = async (row)=>{
        let res = await AdvancedFunApi.getInstance().deleteAllPart(row.id)
        if(res.code === 0){
            message.success(t('access.deleteSuccessful'))
            tableRef.value.expandedRowKeys = []
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 恢复下线
    const restoreOffline = async (row)=>{
        let res = await AdvancedFunApi.getInstance().restoreOffline(row.id)
        if(res.code === 0){
            message.success(t('base.operateSuccess'))
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 导出原始数据
    const rawDataVisible = ref(false)
    const exportLoading = ref(false)
    const exportDates = ref()
    const exportForm = reactive({
        exportType:'',
        frame_number:'',
        dateRange:'',
    })

    const handleExportTypeChange = ()=>{}

    const confirmExportRawData = async ()=>{
        if(!exportForm.exportType){
            message.error(t('access.type')+ ' ' +t('base.noEmpty'))
            return
        }else if(!exportForm.frame_number){
            message.error(t('access.frameNumber')+ ' ' +t('base.noEmpty'))
            return
        }else if(!exportForm.dateRange){
            message.error(t('access.date')+ ' ' +t('base.noEmpty'))
            return
        }

        exportForm.start_date = `${exportForm.dateRange[0].$y}-${exportForm.dateRange[0].$M + 1}-${exportForm.dateRange[0].$D} 00:00:00`
        exportForm.end_date = `${exportForm.dateRange[1].$y}-${exportForm.dateRange[1].$M + 1}-${exportForm.dateRange[1].$D} 23:59:59`
        let param = {
            start_timestamp: dateToTimestamp(exportForm.start_date),
            end_timestamp: dateToTimestamp(exportForm.end_date),
            frame_number: exportForm.frame_number,
            // sys_org: rowData.value.tenant_id,
        }
        exportLoading.value = true
        const exportingText = (t('base.exporting') === 'base.exporting') ? 'exporting' : t('base.exporting')
        const hide = message.loading({ content: exportingText, duration: 0 })
        const ok = await handleDownLoadRawData(param, exportForm.exportType)
        hide()
        if(ok){
            const successText = (t('base.exportSuccess') === 'base.exportSuccess') ? 'Export successfully' : t('base.exportSuccess')
            message.success(successText)
        }
    }

    // 限制日期可选范围（14天内）
    const disabledDate = current => {
        if (!exportDates.value || exportDates.value.length === 0) {
            return false
        }
        const tooLate = exportDates.value[0] && current.diff(exportDates.value[0], 'days') > 14
        const tooEarly = exportDates.value[1] && exportDates.value[1].diff(current, 'days') > 14
        return tooEarly || tooLate
    }
    const onOpenChange = open => {
        if (open) {
            exportDates.value = []
            exportForm.dateRange = []
        }
    }
    const onChange = val => {
        exportForm.dateRange = val
    }
    const onCalendarChange = val => {
        exportDates.value = val
    }

    // 下载电机、电池、仪表、故障原始数据
    const handleDownLoadRawData = async (param, type)=>{
        let res = type == 1? await AdvancedFunApi.getInstance().downloadMotor(param)
                : type == 2? await AdvancedFunApi.getInstance().downloadBattery(param)
                : type == 3? await AdvancedFunApi.getInstance().downloadDisplay(param)
                : await AdvancedFunApi.getInstance().downloadFault(param)

        if (!res.code) {
            let blob = new Blob([res.data])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = type == 1? `${rowData.value.frame_number} ${t('access.motorRawData')}.csv` 
                        : type == 2? `${rowData.value.frame_number} ${t('access.batteryRawData')}.csv` 
                        : type == 3? `${rowData.value.frame_number} ${t('access.displayRawData')}.csv` 
                        : `${rowData.value.frame_number} ${t('access.faultRawData')}.csv`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            exportLoading.value = false
            return true
        } else {
            Modal.error({ title: t('base.tip'), content: res.msg })
            exportLoading.value = false
            return false
        }
    }
    // 删除部件
    const deletePart = async (row)=>{
        let res = await AdvancedFunApi.getInstance().deletePart(rowData.value.id, row.id)
        if(res.code === 0){
            message.success(t('access.deleteSuccessful'))
            tableRef.value.expandedRowKeys = []   
            getVehicleList() 
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取展开的部件数据
    const getPartsVersion = async (id)=>{
        let partNoArr = ['0022','00d2','0028','00f4'] // p100, 仪表:0022,电池:00d2,  p101c: 仪表:0028, 电池:00f4
        table.value.children[0].innerConfigs.loading = true
        let res = await AdvancedFunApi.getInstance().getPartsVersion(id)
        if(res.code === 0){
            let fieldArr = ['assembly_no', 'software_version', 'hardware_version', 'latest_software_version', 'project_no']
            let part_name_transfer = {
                'METER': 'Display',
                'MCU1': 'Drive Unit PCU',
                'MCU2': 'Drive Unit ECU',
                'BMS': 'Battery',
                '中控':'Drive unit ECU',
                '仪表':'Display', 
                '换挡设备':'Remote', 
                '控制器':'Controller', 
                '电控':'Drive unit PCU',
                '电池设备':'Battery',
                '蓝牙':'Bluetooth', 
                '钥匙':'Key',
            }
            res.data.length > 0 && res.data.forEach(item=>{
                fieldArr.map(m=>{
                    item[m] = getFieldVal(item[m])
                })
                item.part_name = part_name_transfer[item.part_name] || item.part_name || '-'
                item.disabled = partNoArr.includes(item.part_no)? false : rowData.value.user_id != undefined
                
            })

            table.value.children[0].innerData = res.data
            if(userInfo.value.tenant_id == 1 && userInfo.value.role.split(',').includes(roleSupperAuth) && table.value.children[0].innerColumns.length == 6){
                table.value.children[0].innerColumns.splice(5, 0, 
                        {
                            title: t('access.project_no'),//'项目编号'
                            dataIndex: 'project_no',
                            key: 'project_no',
                            // width: 100,
                            // resizable: true,
                        }
                    )
                
            } else if(table.value.children[0].innerColumns.length == 7 && (userInfo.value.tenant_id != 1 || !userInfo.value.role.split(',').includes(roleSupperAuth))) {
                table.value.children[0].innerColumns.splice(5, 1)
            }
            table.value.children[0].innerConfigs.loading = false
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 重置
    const resetVisible = ()=>{
        configInfoVisible.value= false
        torqueVisible.value= false
        currentSettingVisible.value= false
        bindRecordVisible.value= false
        applyRecordVisible.value = false
        poweronInfoVisible.value= false
        poweronPositionVisible.value = false
        ebikeSettingVisible.value = false
        ebikeRepairVisible.value = false
        ebikeAuthVisible.value = false
        summaryVisible.value = false
        logVisible.value = false

        modalWidth.value = '75%'
    }

    // 获取权限功能点
    const getDropdownMenu = (data)=>{
        showDeletePartBtn.value = data.some(item => item.menu_name == 'access.deletePart')
        dropdownMenu.value = data.filter(item => item.menu_name !== 'access.deletePart')
            .map((item, index) => ({
                name: t(item.menu_name),
                key: item.menu_name.split('.')[1],
                disabled: false,
            }))
        dropMenuItemKeys.value = dropdownMenu.value.map(item=>item.key)
    }

    // 设置功能点是否禁用
    const getFunDisabled = (row, key)=>{
        switch(key){
            case 'torqueUpgrade':
                return row.vehicle_status != undefined && row.change_torque != undefined
            case 'unbindUser':
                return row.user_id == undefined
            case 'paramConfig':
                return false
            case 'motorReplace':
                return row.change_motor != undefined
            case 'wheelCircumference':
                return row.change_motor == 1
            case 'maxSpeed':
                return row.change_motor == 1
            // case 'deletePartAll':
            //     return row.user_id != undefined
            case 'reStoreOffline':
                return false // row.vehicle_status == undefined
            // case 'cancelWheelCircumference':
            //     if(!row.change_config_items) return true
            //     return !row.change_config_items.split(';').includes('1A05')
            // case 'cancelMaxSpeed':
            //     if(!row.change_config_items) return true
            //     return !row.change_config_items.split(';').includes('0003')
        }
    }

    // 保存轮径/最大速度
    const saveWheelCircumferenceAndMaxSpeed = async()=>{
        if(editModalType.value == 'wheelCircumference' && !rowData.value.wheel_circumference){
            message.error(t('access.wheelCircumference')+' '+t('base.noEmpty'))
            return
        }
        if(editModalType.value == 'maxSpeed' && !rowData.value.max_speed){
            message.error(t('access.maxSpeed')+' '+t('base.noEmpty'))
            return
        }

        let param = {
            config_item: editModalType.value == 'wheelCircumference'? '1A05' : '0003',
            config_value: editModalType.value == 'wheelCircumference'? Math.round(divide(rowData.value.wheel_circumference, 6.28)) : rowData.value.max_speed,
        }
        if(editModalType.value == 'wheelCircumference') param.wheel_circumference = rowData.value.wheel_circumference
        let res = await AdvancedFunApi.getInstance().saveWheelCircumferenceAndMaxSpeed(param, rowData.value.frame_number)
        if(res.code === 0){
            message.success(t('base.saveSuccessMsg'))
            editModalVisible.value = false
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 取消轮径和最大速度变更
    // const cancelWheelCircumferenceAndMaxSpeed = async (row, type)=>{
    //     let param = {
    //         config_item: type == 'wheelCircumference'? '1A05' : '0003',
    //     }
    //     let res = await AdvancedFunApi.getInstance().cancelWheelCircumferenceAndMaxSpeed(param, row.frame_number)
    //     if(res.code === 0){
    //         message.success(t('base.cancelSuccessMsg'))
    //         getVehicleList()
    //     }else{
    //         message.error(res.msg || res.message)
    //     }
    // }

    // 获取租户列表
    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code === 0){
            tenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            tenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: null,
            })
        }
    }

    const cancelEditModal = ()=>{
        editModalVisible.value = false
        getVehicleList()
    }

    // 绑定SKU
    const handleSKU = async ()=>{
        if(!sku.value){
            message.error(t('access.sku')+' '+t('base.noEmpty'))
            return
        }
        let param = {
            sku: sku.value,
        }
        let res = await AdvancedFunApi.getInstance().bindSKU(param, rowData.value.id)
        if(res.code === 0){
            message.success(t('base.saveSuccessMsg'))
            skuVisible.value = false
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 车型是否支持人体工学调节
    const handleMVP = async ()=>{
        if(mvp.value === '' || mvp.value === undefined){
            message.error(t('access.mvp')+' '+t('base.noEmpty'))
            return
        }
        let param = {
            mvp: mvp.value,
        }
        let res = await AdvancedFunApi.getInstance().editMVP(param, rowData.value.id)
        if(res.code === 0){
            message.success(t('base.saveSuccessMsg'))
            mvpVisible.value = false
            getVehicleList()
        }else{
            message.error(res.msg || res.message)
        }
    }


    const getSKUList = async ()=>{
        let param = {
            sku: sku.value,
        }
        let res = await AdvancedFunApi.getInstance().getSKUList(param)
        if(res.code === 0){
            skuOptions.value = res.data.map(item => ({
                label: item,
                value: item,
            }))
        }else{
            message.error(res.msg || res.message)
        }
    }

    const fetchSKU = useDebounceFn(async (val)=>{
        sku.value = val
        getSKUList()
    },300) 

    const handleFocus = ()=>{
        sku.value = ''
        getSKUList()
    }

    watch(()=>store.funList,(val)=>{
        getDropdownMenu(val)
        console.log(dropdownMenu.value,'dropdownMenu.value')
    })

    // 监听logActiveKey变化，切换tab时重置表格列
    watch(logActiveKey, (val) => {
        logTable.value.columns = getLogColumns(val)
        logTable.value.configs.pagination = val == 4? false : {
            hideOnSinglePage:false,
            position:['bottomLeft'],
            responsive:true, // size 未指定时，根据屏幕宽度自动调整尺寸
            current:1,
            pageSize:10,
            pageSizeOptions:['10','20','50'],
            total:0,
            showTotal:()=>t('base.total') + ` ${logTable.value.configs.pagination.total} ` + t('base.row')
        }
        if(val != 4) logTable.value.configs.pagination.current = 1
        if(val == '4'){
            getErrorLog(rowData.value)
        }else if(val == '5'){
            getFaultLog(rowData.value)
        }else{
            getLogList(rowData.value)
        }
    })

    onMounted(async ()=>{
        await getDropdownMenu(store.funList)
        getVehicleList()
        getFrameAndMotor()
        getTenantList()
        getSKUList()

        
        console.log(store.funList,'store.funList')
    })
</script>

<style lang="scss" scoped>
.ble-filter{
    margin: 10px 0 6px 0;
}
.operate_btn{
    margin-top: 30px;
}

.table_title{
    margin: 30px 0 20px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
}

.chart_block{
    margin: 45px 0 15px;

    .chart{
        display: flex;

        #torqueChart,
        #torqueChart2,
        #torqueChart3,
        #torqueChart4,
        #torqueChart5,
        #torqueChart6,
        #torqueChart7,
        #torqueChart8{
            margin-top: 10px;
            margin-right: 50px;
            padding: 10px;
            width: 500px;
            background: #fff;
            border-radius: 9px;
        }
    }
}

.queryUserTitle{
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    line-height: 16px;
    color: #1226AA;
}

.query_box{
    margin-top: 30px;
    margin-bottom: 20px;

    .query_field{
        margin-right: 10px;
        margin-bottom: 5px;
        width: 220px;
    }
}



::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

// 子表格的表体行样式
::v-deep .subTableBg{
    background: #f6f6f6 !important;
}

.vehicleInfo{
    // float: left;
    padding: 10px 0 20px;
    margin-top: -10px;
    color: #1226aa;
    font-weight: 600;

    & > div{
        display: inline-block;
        margin: 0 50px 0 0;
    }
}

::v-deep .versionTable{
    .ant-table-thead > tr > th{
        padding: 5px 5px;
        background: #1226aa;
        color: #fff;
    }
    .ant-table-tbody > tr > td{
        padding: 5px 5px;
    }
}

::v-deep .configChangeItemTable{
    .ant-table-thead > tr > th{
        padding: 5px 5px;
        background: red;
        color: #fff;
        border-radius: 0px;
    }

    .ant-table-tbody > tr > td{
        padding: 5px 5px;
    }
}

::v-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header{
    padding: 7px 16px;
}

.config_name{
    display: flex;

    .name_lang{
        display: flex;
        flex:1;
        width:50px;
    }
    .name_value{
        display: flex;
        flex:6;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
    }
}

::v-deep .ant-modal{
    min-width: 1000px !important;
}

.versionHeader{
    display: flex;

    .versionHeaderLeft{
        display: flex;
        flex: 10;
    }

    .versionHeaderRight{
        display: flex;
        flex: 1;
    }
}

.wheelCircumferenceInfo{
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 5px;
    background-color: #f0f2f5;
    font-weight: 600;
}

.marginTop5{
    margin-top: 5px
}
.marginTop10{
    margin-top: 10px
}

.marginBottom5{
    margin-bottom: 5px
}
.marginBottom10{
    margin-bottom: 10px
}

.color_666{
    color: #666
}
.color_ccc{
    color: #ccc
}
.color_4b2cc3{
    color: #4b2cc3
}

.font11{
    font-size: 11px;
}
.font12{
    font-size: 12px;
}
.font13{
    font-size: 13px;
}
.font14{
    font-size: 14px;
}
.font15{
    font-size: 15px;
}

.exportFormItem{
    margin-bottom: 16px;
}

.required{
    color: red;
    margin-right: 5px;
}

.exportLabel{
    display: inline-block;
    width: 110px;
    text-align: right;
    margin-right: 8px;
}

.exportFormContainer{
    margin-top: 20px;
    margin-right:25px;
}

.exportActions{
    margin-top: 25px;
    margin-left:25px;
}

.ergoAdjustForm{
    margin-top: 20px;
}

::v-deep .ant-input-number-group-addon{
    width:50px !important;
}
::v-deep .ant-descriptions-item-label{
    font-weight: 600;
    background:#f1f1f1 !important;
}
</style>